document.addEventListener('DOMContentLoaded', function() {
  (function() {
    'use strict';
  
    const DEBUG = window.location.search.includes('debug=true');
  
    function trapFocus(container) {
      const focusable = container.querySelectorAll('button, input, select, a[href]');
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      first.focus();
      container.addEventListener('keydown', function(e) {
        if (e.key !== 'Tab') return;
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      });
    }
  
    DEBUG && console.log('🔍 Initializing Meilisearch search...');
  
    // XSS protection
    function escapeHtml(str) {
      const div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }
  
    // Sanitize HTML — strips dangerous tags/attributes but preserves safe formatting
    function sanitizeHtml(html) {
      if (!html) return '';
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      // Remove dangerous tags
      const dangerousTags = ['script', 'iframe', 'object', 'embed', 'form', 'input', 'textarea', 'select', 'button'];
      dangerousTags.forEach(tag => {
        doc.querySelectorAll(tag).forEach(el => el.remove());
      });
      // Remove SVGs with event handlers
      doc.querySelectorAll('svg').forEach(svg => {
        const attrs = Array.from(svg.attributes);
        if (attrs.some(a => a.name.startsWith('on'))) svg.remove();
      });
      // Strip all on* event attributes from remaining elements
      doc.querySelectorAll('*').forEach(el => {
        Array.from(el.attributes).forEach(attr => {
          if (attr.name.startsWith('on')) el.removeAttribute(attr.name);
          if (attr.value && attr.value.replace(/\s/g, '').toLowerCase().startsWith('javascript:')) {
            el.removeAttribute(attr.name);
          }
        });
      });
      return doc.body.innerHTML;
    }
  
    // Price formatting helper - adds commas for thousands
    function formatPrice(price) {
      return price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
  
    // Image optimization helper - generates WebP URL at specified width from Shopify CDN URL
    function shopifyImageUrl(url, width) {
      if (!url) return '';
      const base = url.split('?')[0];
      const params = new URLSearchParams(url.includes('?') ? url.split('?')[1] : '');
      const v = params.get('v') || '';
      return `${base}?width=${width}&format=webp${v ? '&v=' + v : ''}`;
    }
  
    // Generate srcset string for responsive images
    function shopifyImageSrcset(url, widths) {
      if (!url) return '';
      return widths.map(w => `${escapeHtml(shopifyImageUrl(url, w))} ${w}w`).join(', ');
    }
  
    const urlParams = new URLSearchParams(window.location.search);
    const searchQuery = urlParams.get('q') || '';
  
    // Search proxy — API key stays server-side
    const SEARCH_PROXY_BASE = 'https://search.bbqing.com/api/proxy';
    const index = {
      search: async function(q, params) {
        const body = Object.assign({}, params || {}, { q: q || '' });
        const res = await fetch(SEARCH_PROXY_BASE + '/search/shopify_content', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        });
        if (!res.ok) throw new Error('Search request failed: ' + res.status);
        return res.json();
      }
    };
  
    // Mobile filter functions - defined early so they work even without search query
    window.toggleMobileFilters = function() {
      const sidebar = document.getElementById('search-filters');
      const overlay = document.getElementById('mobile-filter-overlay');
      const isOpen = sidebar.style.transform === 'translateX(0%)';
  
      if (isOpen) {
        sidebar.style.transform = 'translateX(-100%)';
        if (overlay) overlay.classList.remove('active');
        document.body.style.overflow = '';
      } else {
        sidebar.style.transform = 'translateX(0%)';
        if (overlay) overlay.classList.add('active');
        document.body.style.overflow = 'clip';
        trapFocus(sidebar);
      }
    };
  
    window.closeMobileFilters = function() {
      const sidebar = document.getElementById('search-filters');
      const overlay = document.getElementById('mobile-filter-overlay');
      sidebar.style.transform = 'translateX(-100%)';
      if (overlay) overlay.classList.remove('active');
      document.body.style.overflow = '';
    };
  
    if (!searchQuery || searchQuery.trim().length < 1) {
      document.getElementById('search-loading').innerHTML = '<p style="color: #999;">Enter a search term to begin</p>';
      return;
    }
  
    // ==================== AUTOCOMPLETE FUNCTIONALITY ====================
    const searchInput = document.getElementById('search-input-main');
    const autocompleteDropdown = document.getElementById('autocomplete-dropdown');
    const autocompleteResults = document.getElementById('autocomplete-results');
    let autocompleteTimeout;
    let selectedSuggestionIndex = -1;
  
    function debounce(func, wait) {
      return function(...args) {
        clearTimeout(autocompleteTimeout);
        autocompleteTimeout = setTimeout(() => func.apply(this, args), wait);
      };
    }
  
    const handleAutocomplete = debounce(async function(e) {
      const query = e.target.value.trim();
  
      if (query.length < 2) {
        autocompleteDropdown.style.display = 'none';
        return;
      }
  
      try {
        const response = await index.search(query, {
          filter: 'content_type = product AND status = "active"',
          limit: 5,
          attributesToRetrieve: ['id', 'full_title', 'image_url', 'price', 'vendor', 'url']
        });
  
        // Get recently viewed products
        const recentlyViewed = await getRecentlyViewedProducts();
  
        if (response.hits.length === 0 && recentlyViewed.length === 0) {
          autocompleteDropdown.style.display = 'none';
          return;
        }
  
        selectedSuggestionIndex = -1;
        displayAutocompleteSuggestions(response.hits, recentlyViewed, query);
      } catch (error) {
        DEBUG && console.error('Autocomplete error:', error);
      }
    }, 300);
  
    function displayAutocompleteSuggestions(products, recentlyViewed = [], searchQuery = '') {
      let html = '';
      let index = 0;
      const escQuery = escapeHtml(searchQuery).replace(/'/g, "\\'");
  
      // Show search results
      if (products.length > 0) {
        html += products.map((product, i) => `
          <a href="${escapeHtml(product.url)}"
             data-index="${index++}"
             style="display: flex; align-items: center; gap: 12px; padding: 12px; text-decoration: none; color: inherit; border-bottom: 1px solid #f3f4f6; transition: background 0.15s;"
             onmouseover="this.style.background='#f9fafb'"
             onmouseout="this.style.background='white'"
             onclick="trackProductView('${product.id}'); if(window.MeiliAnalytics) MeiliAnalytics.trackClick('${escQuery}', '${product.id}', '', ${i + 1}, 'search-dropdown');">
            <img src="${escapeHtml(shopifyImageUrl(product.image_url, 100))}" alt="${escapeHtml(product.full_title)}"
                 style="width: 50px; height: 50px; object-fit: contain; border-radius: 4px; background: #f9fafb; flex-shrink: 0;">
            <div style="flex: 1; min-width: 0;">
              ${product.vendor ? `<div style="font-size: 11px; color: #4b5563; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 2px; font-weight: 600;">${escapeHtml(product.vendor)}</div>` : ''}
              <div style="font-size: 14px; font-weight: 500; color: #1a1a1a; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${escapeHtml(product.full_title)}</div>
            </div>
            <div style="font-size: 15px; font-weight: 700; color: #1a1a1a; flex-shrink: 0;">$${formatPrice(product.price)}</div>
          </a>
        `).join('');
      }
  
      // Show recently viewed section
      if (recentlyViewed.length > 0) {
        html += `
          <div style="padding: 10px 12px; background: #f9fafb; border-top: 2px solid #e5e7eb; border-bottom: 1px solid #f3f4f6;">
            <div style="font-size: 11px; color: #4b5563; text-transform: uppercase; letter-spacing: 1px; font-weight: 700;">Recently Viewed</div>
          </div>
        `;
  
        html += recentlyViewed.map((product, i) => `
          <a href="${escapeHtml(product.url)}"
             data-index="${index++}"
             style="display: flex; align-items: center; gap: 12px; padding: 12px; text-decoration: none; color: inherit; border-bottom: 1px solid #f3f4f6; transition: background 0.15s;"
             onmouseover="this.style.background='#f9fafb'"
             onmouseout="this.style.background='white'"
             onclick="trackProductView('${product.id}'); if(window.MeiliAnalytics) MeiliAnalytics.trackClick('', '${product.id}', '', ${i + 1}, 'search-dropdown-recent');">
            <img src="${escapeHtml(shopifyImageUrl(product.image_url, 100))}" alt="${escapeHtml(product.full_title)}"
                 style="width: 50px; height: 50px; object-fit: contain; border-radius: 4px; background: #f9fafb; flex-shrink: 0;">
            <div style="flex: 1; min-width: 0;">
              ${product.vendor ? `<div style="font-size: 11px; color: #4b5563; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 2px; font-weight: 600;">${escapeHtml(product.vendor)}</div>` : ''}
              <div style="font-size: 14px; font-weight: 500; color: #1a1a1a; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${escapeHtml(product.full_title)}</div>
            </div>
            <div style="font-size: 15px; font-weight: 700; color: #1a1a1a; flex-shrink: 0;">$${formatPrice(product.price)}</div>
          </a>
        `).join('');
      }
  
      autocompleteResults.innerHTML = html;
      autocompleteDropdown.style.display = 'block';
    }
  
    function handleAutocompleteKeyboard(e) {
      if (!autocompleteDropdown || autocompleteDropdown.style.display === 'none') return;
  
      const suggestions = autocompleteResults.querySelectorAll('a');
      if (suggestions.length === 0) return;
  
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        selectedSuggestionIndex = (selectedSuggestionIndex + 1) % suggestions.length;
        updateSelectedSuggestion(suggestions);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        selectedSuggestionIndex = selectedSuggestionIndex <= 0 ? suggestions.length - 1 : selectedSuggestionIndex - 1;
        updateSelectedSuggestion(suggestions);
      } else if (e.key === 'Enter' && selectedSuggestionIndex >= 0) {
        e.preventDefault();
        suggestions[selectedSuggestionIndex].click();
      } else if (e.key === 'Escape') {
        autocompleteDropdown.style.display = 'none';
      }
    }
  
    function updateSelectedSuggestion(suggestions) {
      suggestions.forEach((suggestion, index) => {
        if (index === selectedSuggestionIndex) {
          suggestion.style.background = '#f9fafb';
          suggestion.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        } else {
          suggestion.style.background = 'white';
        }
      });
    }
  
    // Add autocomplete event listeners after functions are defined
    if (searchInput) {
      searchInput.addEventListener('input', handleAutocomplete);
      searchInput.addEventListener('keydown', handleAutocompleteKeyboard);
    }
  
    // ==================== RECENTLY VIEWED PRODUCTS ====================
    function trackProductView(productId) {
      let recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed') || '[]');
  
      // Remove if already exists
      recentlyViewed = recentlyViewed.filter(id => id !== productId);
  
      // Add to beginning
      recentlyViewed.unshift(productId);
  
      // Keep only last 10
      recentlyViewed = recentlyViewed.slice(0, 10);
  
      localStorage.setItem('recentlyViewed', JSON.stringify(recentlyViewed));
    }
  
    async function getRecentlyViewedProducts() {
      const recentlyViewedIds = JSON.parse(localStorage.getItem('recentlyViewed') || '[]');
      if (recentlyViewedIds.length === 0) return [];
  
      try {
        // Fetch products from Meilisearch
        const response = await index.search('', {
          filter: 'content_type = product AND status = "active"',
          limit: 100,
          attributesToRetrieve: ['id', 'full_title', 'image_url', 'price', 'vendor', 'url']
        });
  
        // Match and sort by recently viewed order
        const matchedProducts = recentlyViewedIds
          .map(id => response.hits.find(hit => hit.id === id))
          .filter(product => product !== undefined)
          .slice(0, 3); // Show max 3 recently viewed
  
        return matchedProducts;
      } catch (error) {
        DEBUG && console.error('Error fetching recently viewed:', error);
        return [];
      }
    }
  
  
    // ==================== MAIN SEARCH FUNCTIONALITY ====================
  
    let allProducts = [];
    let displayedProducts = [];
    let currentPage = 1;
    let productsPerPage = 100;  // Match Meilisearch limit, use pagination for more
    let totalEstimatedHits = 0;  // Track total results for pagination
    let reachedRelevanceFloor = false;  // Track if results dropped below relevance threshold
  
    // GWP promo tags for badge display
    let gwpPromoTags = [];
    fetch('https://search.bbqing.com/api/gift-with-purchase')
      .then(function(r) { return r.json(); })
      .then(function(promos) {
        gwpPromoTags = promos.filter(function(p) { return p.triggerType === 'tag'; }).map(function(p) { return p.triggerValue; });
      })
      .catch(function() {});
  
    function hasGwpPromo(tags) {
      if (!tags || !tags.length) return false;
      // Tag-based promo triggers (e.g. gwp-baron-griddle for the Broil King rule).
      if (gwpPromoTags.length && gwpPromoTags.some(function(t) { return tags.indexOf(t) !== -1; })) return true;
      // Variant-based promo triggers — products manually tagged gwp-trigger in Shopify Admin.
      if (tags.indexOf('gwp-trigger') !== -1) return true;
      return false;
    }
    let showingAccessories = false;  // Track if showing accessories fallback
    let priceExtracted = null;  // Track extracted price for messaging
    let cleanedQuery = '';  // Track cleaned query after price extraction
    let facetDistribution = {};  // Store facet counts from Meilisearch
    let currentFilters = { brands: new Set(), types: new Set(), colors: new Set(), fuelTypes: new Set(), priceMin: null, priceMax: null, newArrival: false, promotion: false, clearance: false, canadianBrands: false, taxonomy: { configuration: new Set() }, series: new Set(), mainBurners: new Set(), sideBurners: new Set(), rearRotisserie: new Set(), metafields: {} };
    let currentSort = 'relevance';
    let userChangedSort = false; // Track if user explicitly changed sort (vs global default)
    let compareProducts = new Set(JSON.parse(localStorage.getItem('compareProducts') || '[]'));
    const MAX_COMPARE = 4;
    let sortingRules = { global: null };
  
    // Fetch sorting rules from dashboard
    async function fetchSortingRules() {
      try {
        const response = await fetch('https://search.bbqing.com/api/boost-rules');
        const data = await response.json();
        DEBUG && console.log('🔀 Full boost-rules API response:', data);
        sortingRules = data.collectionSortingRules || { global: null };
        DEBUG && console.log('🔀 Global sort from API:', sortingRules.global);
      } catch (error) {
        DEBUG && console.error('Error fetching sorting rules:', error);
        sortingRules = { global: null };
      }
    }
  
    // Get the default sort order — search pages always default to relevance
    // Global sort (e.g., price:desc) only applies to collection/browse pages
    function getDefaultSort() {
      let defaultSort = 'relevance';
  
      // Map Meilisearch format to select dropdown format
      const sortMap = {
        'price:asc': 'price-asc',
        'price:desc': 'price-desc',
        'inventory_quantity:desc': 'inventory-desc',
        'inventory_quantity:asc': 'inventory-asc',
        'created_at:desc': 'newest',
        'created_at:asc': 'oldest'
      };
  
      return sortMap[defaultSort] || defaultSort;
    }
  
    // Filter configuration (loaded from dashboard)
    let filterConfig = null;
    let COLOR_FAMILIES = {};
  
    // Load filter configuration from dashboard API (for color families)
    async function loadFilterConfig() {
      try {
        const response = await fetch('https://search.bbqing.com/api/filter-config');
        filterConfig = await response.json();
        COLOR_FAMILIES = filterConfig.colorFamilies || {};
        window.filterConfig = filterConfig;
        renderFilterSections();
        DEBUG && console.log('✅ Filter configuration loaded from dashboard');
      } catch (error) {
        DEBUG && console.error('⚠️ Error loading filter config:', error);
        COLOR_FAMILIES = {};
        renderFilterSections();
      }
    }
  
    // Render dropdown filter sections in fixed order
    function renderFilterSections() {
      const container = document.getElementById('dynamic-filters-container');
      if (!container) return;
  
      const dropdownFilter = (id, label) => `
        <div style="margin-bottom: 16px; padding-bottom: 16px; border-bottom: 1px solid #e7e7e7;">
          <h4 onclick="toggleFilterSection('${id}')" style="font-size: 13px; font-weight: 600; margin-bottom: 12px; color: #1a1a1a; cursor: pointer; display: flex; justify-content: space-between; align-items: center; user-select: none;">
            <span>${label}</span>
            <svg id="${id}-arrow" width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2" style="transition: transform 0.2s;">
              <path d="M3 5l3 3 3-3"/>
            </svg>
          </h4>
          <div id="${id}-filter-options" style="display: none;"></div>
        </div>
      `;
  
      const offersBlock = `
        <div id="current-offers-block" style="margin-bottom: 16px; padding-bottom: 16px; border-bottom: 1px solid #e7e7e7; display: none;">
          <h4 onclick="toggleFilterSection('current-offers')" style="font-size: 13px; font-weight: 600; margin-bottom: 12px; color: #1a1a1a; cursor: pointer; display: flex; justify-content: space-between; align-items: center; user-select: none;">
            <span>Current Offers</span>
            <svg id="current-offers-arrow" width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2" style="transition: transform 0.2s; transform: rotate(180deg);">
              <path d="M3 5l3 3 3-3"/>
            </svg>
          </h4>
          <div id="current-offers-filter-options" style="display: block;"></div>
        </div>
      `;

      container.innerHTML = [
        offersBlock,
        dropdownFilter('brand', 'Brand'),
        dropdownFilter('taxonomy-configuration', 'Configuration'),
        dropdownFilter('fuel-type', 'Fuel Type'),
        dropdownFilter('type', 'Product Type'),
        // Price
        `<div style="margin-bottom: 20px; padding-bottom: 20px; border-bottom: 1px solid #e7e7e7;">
          <h4 style="font-size: 13px; font-weight: 600; margin-bottom: 12px; color: #1a1a1a;">Price</h4>
          <div style="display: grid; grid-template-columns: 1fr auto 1fr; gap: 8px; align-items: center; margin-bottom: 16px;">
            <input type="number" id="price-min" placeholder="$0" min="0" style="padding: 10px; border: 1px solid #e5e7eb; border-radius: 6px; font-size: 13px; width: 100%; box-sizing: border-box; background: white; transition: border-color 0.2s;" onfocus="this.style.borderColor='#1a1a1a'; this.style.outline='none'" onblur="this.style.borderColor='#e5e7eb'">
            <span style="color: #d1d5db;">–</span>
            <input type="number" id="price-max" placeholder="$9,999" min="0" style="padding: 10px; border: 1px solid #e5e7eb; border-radius: 6px; font-size: 13px; width: 100%; box-sizing: border-box; background: white; transition: border-color 0.2s;" onfocus="this.style.borderColor='#1a1a1a'; this.style.outline='none'" onblur="this.style.borderColor='#e5e7eb'">
          </div>
          <div style="position: relative; height: 6px; background: #e5e7eb; border-radius: 3px; margin-bottom: 8px;">
            <div id="price-slider-range" style="position: absolute; height: 100%; background: #1a1a1a; border-radius: 3px; left: 0; right: 0;"></div>
            <input type="range" id="price-slider-min" min="0" max="10000" value="0" step="10" style="position: absolute; width: 100%; height: 6px; -webkit-appearance: none; appearance: none; background: transparent; pointer-events: none; margin: 0;">
            <input type="range" id="price-slider-max" min="0" max="10000" value="10000" step="10" style="position: absolute; width: 100%; height: 6px; -webkit-appearance: none; appearance: none; background: transparent; pointer-events: none; margin: 0;">
          </div>
        </div>`,
        dropdownFilter('series', 'Series'),
        dropdownFilter('main-burners', 'Main Burners'),
        dropdownFilter('side-burners', 'Side Burners'),
        dropdownFilter('rear-rotisserie', 'Rear/Rotisserie Burner'),
        // Color — last filter, no bottom border/margin
        `<div>
          <h4 onclick="toggleFilterSection('color')" style="font-size: 13px; font-weight: 600; margin-bottom: 12px; color: #1a1a1a; cursor: pointer; display: flex; justify-content: space-between; align-items: center; user-select: none;">
            <span>Color</span>
            <svg id="color-arrow" width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2" style="transition: transform 0.2s;">
              <path d="M3 5l3 3 3-3"/>
            </svg>
          </h4>
          <div id="color-filter-options" style="display: none;"></div>
        </div>`
      ].join('');
  
      refreshDynamicEls();
      initPriceSliders();
      DEBUG && console.log('🔧 Rendered filter sections');
    }
  
    // Initialize price slider event listeners
    function initPriceSliders() {
      const priceMin = document.getElementById('price-min');
      const priceMax = document.getElementById('price-max');
      const sliderMin = document.getElementById('price-slider-min');
      const sliderMax = document.getElementById('price-slider-max');
  
      if (!priceMin || !priceMax || !sliderMin || !sliderMax) return;
  
      // Update element references
      els.priceMin = priceMin;
      els.priceMax = priceMax;
      els.priceSliderMin = sliderMin;
      els.priceSliderMax = sliderMax;
      els.priceSliderRange = document.getElementById('price-slider-range');
  
      // Attach event listeners (only once)
      attachPriceSliderListeners();
    }
  
    // Get all matching color families for a color (supports split colors like "Black/Stainless Steel")
    function getColorFamilies(color) {
      if (!color) return [];
      const colorLower = color.toLowerCase().trim();
      const matched = [];
      for (const [family, variants] of Object.entries(COLOR_FAMILIES)) {
        if (variants.some(v => colorLower.includes(v) || v.includes(colorLower))) {
          matched.push(family);
        }
      }
      return matched.length > 0 ? matched : [color]; // Return original if no family match
    }
  
    const els = {
      loading: document.getElementById('search-loading'),
      noResults: document.getElementById('no-results'),
      resultsGrid: document.getElementById('search-results-grid'),
      resultsHeader: document.getElementById('results-header'),
      resultsCount: document.getElementById('results-count'),
      // These are populated dynamically after renderFilterSections()
      brandOptions: null,
      typeOptions: null,
      colorOptions: null,
      priceMin: null,
      priceMax: null,
      priceSliderMin: null,
      priceSliderMax: null,
      priceSliderRange: null,
      // Static elements
      newArrivalToggle: document.getElementById('filter-new-arrival'),
      promotionToggle: document.getElementById('filter-promotion'),
      clearanceToggle: document.getElementById('filter-clearance'),
      canadianBrandsToggle: document.getElementById('filter-canadian-brands'),
      sortSelect: document.getElementById('sort-select'),
      clearAll: document.getElementById('clear-all-filters'),
      activeFilters: document.getElementById('active-filters')
    };
  
    // Refresh dynamic element references after filters are rendered
    function refreshDynamicEls() {
      els.brandOptions = document.getElementById('brand-filter-options');
      els.typeOptions = document.getElementById('type-filter-options');
      els.colorOptions = document.getElementById('color-filter-options');
      els.fuelTypeOptions = document.getElementById('fuel-type-filter-options');
      els.configurationOptions = document.getElementById('taxonomy-configuration-filter-options');
      els.seriesOptions = document.getElementById('series-filter-options');
      els.mainBurnersOptions = document.getElementById('main-burners-filter-options');
      els.sideBurnersOptions = document.getElementById('side-burners-filter-options');
      els.rearRotisserieOptions = document.getElementById('rear-rotisserie-filter-options');
      els.priceMin = document.getElementById('price-min');
      els.priceMax = document.getElementById('price-max');
      els.priceSliderMin = document.getElementById('price-slider-min');
      els.priceSliderMax = document.getElementById('price-slider-max');
      els.priceSliderRange = document.getElementById('price-slider-range');
    }
  
    // Initialize app - load filter config and sorting rules then perform search
    (async function init() {
      await Promise.all([loadFilterConfig(), fetchSortingRules()]);
      initFromURL();
  
      // Apply default sort if no sort parameter in URL
      const params = new URLSearchParams(window.location.search);
      DEBUG && console.log('🔀 URL has sort param?', params.has('sort'));
      if (!params.has('sort')) {
        const defaultSort = getDefaultSort();
        DEBUG && console.log('🔀 Default sort from getDefaultSort():', defaultSort);
        if (defaultSort !== 'relevance') {
          currentSort = defaultSort;
          DEBUG && console.log('🔀 Setting currentSort to:', currentSort);
          if (els.sortSelect) {
            els.sortSelect.value = defaultSort;
            DEBUG && console.log('🔀 Set dropdown to:', els.sortSelect.value);
          }
        }
      }
  
      performSearch();
    })();
  
    // Sync filters to URL
    function syncToURL() {
      const params = new URLSearchParams();
      params.set('q', searchQuery);
      if (currentFilters.brands.size > 0) params.set('brands', Array.from(currentFilters.brands).join(','));
      if (currentFilters.types.size > 0) params.set('types', Array.from(currentFilters.types).join(','));
      if (currentFilters.colors.size > 0) params.set('colors', Array.from(currentFilters.colors).join(','));
      if (currentFilters.fuelTypes.size > 0) params.set('fuel_types', Array.from(currentFilters.fuelTypes).join(','));
      if (currentFilters.taxonomy.configuration.size > 0) params.set('configuration', Array.from(currentFilters.taxonomy.configuration).join(','));
      if (currentFilters.series.size > 0) params.set('series', Array.from(currentFilters.series).join(','));
      if (currentFilters.mainBurners.size > 0) params.set('main_burners', Array.from(currentFilters.mainBurners).join(','));
      if (currentFilters.sideBurners.size > 0) params.set('side_burners', Array.from(currentFilters.sideBurners).join(','));
      if (currentFilters.rearRotisserie.size > 0) params.set('rear_rotisserie', Array.from(currentFilters.rearRotisserie).join(','));
      if (currentFilters.priceMin) params.set('price_min', currentFilters.priceMin);
      if (currentFilters.priceMax) params.set('price_max', currentFilters.priceMax);
      if (currentFilters.newArrival) params.set('new_arrival', '1');
      if (currentFilters.promotion) params.set('promotion', '1');
      if (currentFilters.clearance) params.set('clearance', '1');
      if (currentFilters.canadianBrands) params.set('canadian_brands', '1');
      // Only add sort to URL if user explicitly changed it (not from global default)
      if (userChangedSort && currentSort !== 'relevance') params.set('sort', currentSort);
  
      const newURL = `${window.location.pathname}?${params.toString()}`;
      window.history.replaceState({}, '', newURL);
    }
  
    function initFromURL() {
      const params = new URLSearchParams(window.location.search);
      if (params.has('brands')) params.get('brands').split(',').forEach(b => currentFilters.brands.add(b));
      if (params.has('types')) params.get('types').split(',').forEach(t => currentFilters.types.add(t));
      if (params.has('colors')) params.get('colors').split(',').forEach(c => currentFilters.colors.add(c));
      if (params.has('fuel_types')) params.get('fuel_types').split(',').forEach(f => currentFilters.fuelTypes.add(f));
      if (params.has('configuration')) params.get('configuration').split(',').forEach(c => currentFilters.taxonomy.configuration.add(c));
      if (params.has('series')) params.get('series').split(',').forEach(s => currentFilters.series.add(s));
      if (params.has('main_burners')) params.get('main_burners').split(',').forEach(b => currentFilters.mainBurners.add(b));
      if (params.has('side_burners')) params.get('side_burners').split(',').forEach(b => currentFilters.sideBurners.add(b));
      if (params.has('rear_rotisserie')) params.get('rear_rotisserie').split(',').forEach(b => currentFilters.rearRotisserie.add(b));
      if (params.has('price_min')) currentFilters.priceMin = parseFloat(params.get('price_min'));
      if (params.has('price_max')) currentFilters.priceMax = parseFloat(params.get('price_max'));
      if (params.has('new_arrival')) currentFilters.newArrival = true;
      if (params.has('promotion')) currentFilters.promotion = true;
      if (params.has('clearance')) currentFilters.clearance = true;
      if (params.has('canadian_brands')) currentFilters.canadianBrands = true;
      if (params.has('sort')) {
        currentSort = params.get('sort');
        userChangedSort = true; // URL had sort param = user explicitly chose this
      }
    }
  
    async function performSearch(loadMore = false) {
      DEBUG && console.log('🔎 Searching for:', searchQuery);
      if (!loadMore) {
        showLoading();
        currentPage = 1;
      }
  
      try {
        const filters = ['content_type = product', 'status = "active"'];
        // Checkbox filters (matching collection template)
        if (currentFilters.newArrival) {
          filters.push('season_code = "2026"');
        }
        if (currentFilters.clearance) filters.push('on_sale = true');
        if (currentFilters.promotion && !currentFilters.clearance) {
          // Include on_sale, GWP-tag-based promo triggers, and gwp-trigger tag (variant-based promos)
          const orClauses = ['on_sale = true', 'tags = "gwp-trigger"'];
          if (gwpPromoTags.length > 0) {
            gwpPromoTags.forEach(t => orClauses.push(`tags = "${t}"`));
          }
          filters.push(`(${orClauses.join(' OR ')})`);
        }
        if (currentFilters.canadianBrands) filters.push('tags = "Canadian Brand"');
  
        // Dropdown filters
        if (currentFilters.brands.size > 0) filters.push(`(${Array.from(currentFilters.brands).map(b => `vendor = "${b}"`).join(' OR ')})`);
        if (currentFilters.taxonomy.configuration.size > 0) filters.push(`(${Array.from(currentFilters.taxonomy.configuration).map(c => `taxonomy_configuration = "${c}"`).join(' OR ')})`);
        if (currentFilters.fuelTypes.size > 0) filters.push(`(${Array.from(currentFilters.fuelTypes).map(f => `fuel_type = "${f}"`).join(' OR ')})`);
        if (currentFilters.types.size > 0) filters.push(`(${Array.from(currentFilters.types).map(t => `taxonomy_category = "${t}"`).join(' OR ')})`);
        if (currentFilters.priceMin !== null && currentFilters.priceMin > 0) filters.push(`price >= ${currentFilters.priceMin}`);
        if (currentFilters.priceMax !== null && currentFilters.priceMax > 0) filters.push(`price <= ${currentFilters.priceMax}`);
        if (currentFilters.series.size > 0) filters.push(`(${Array.from(currentFilters.series).map(s => `"general_specs.series" = "${s}"`).join(' OR ')})`);
        if (currentFilters.mainBurners.size > 0) filters.push(`(${Array.from(currentFilters.mainBurners).map(m => `"bbq_specs.main_burner_count" = "${m}"`).join(' OR ')})`);
        if (currentFilters.sideBurners.size > 0) filters.push(`(${Array.from(currentFilters.sideBurners).map(s => `"bbq_specs.side_burner_included" = "${s}"`).join(' OR ')})`);
        if (currentFilters.rearRotisserie.size > 0) {
          const rrConditions = Array.from(currentFilters.rearRotisserie).flatMap(v => [`"bbq_specs.rotisserie_included" = "${v}"`, `"bbq_specs.rear_burner_included" = "${v}"`]);
          filters.push(`(${rrConditions.join(' OR ')})`);
        }
  
        // Color family filtering
        if (currentFilters.colors.size > 0) {
          const colorConditions = [];
          Array.from(currentFilters.colors).forEach(family => {
            const familyVariants = COLOR_FAMILIES[family];
            if (familyVariants && familyVariants.length > 0) {
              familyVariants.forEach(variant => colorConditions.push(`color = "${variant}"`));
            } else {
              colorConditions.push(`color = "${family}"`);
            }
          });
          if (colorConditions.length > 0) filters.push(`(${colorConditions.join(' OR ')})`);
        }
  
        // Metafield filters
        Object.entries(currentFilters.metafields).forEach(([metafieldKey, values]) => {
          if (values && values.size > 0) {
            const conditions = Array.from(values).map(v => `"${metafieldKey}" = "${v}"`);
            filters.push(`(${conditions.join(' OR ')})`);
          }
        });
  
        let sort = [];
        if (currentSort === 'price-asc') sort = ['price:asc'];
        else if (currentSort === 'price-desc') sort = ['price:desc'];
        else if (currentSort === 'inventory-desc') sort = ['inventory_quantity:desc'];
        else if (currentSort === 'inventory-asc') sort = ['inventory_quantity:asc'];
        else if (currentSort === 'newest') sort = ['created_at:desc'];
        else if (currentSort === 'oldest') sort = ['created_at:asc'];
        // Handle Meilisearch format directly (from sorting rules)
        else if (currentSort.includes(':')) sort = [currentSort];
  
        // Build facets array matching collection
        const baseFacets = ['vendor', 'product_type', 'color', 'on_sale', 'tags', 'season_code', 'general_specs.series', 'bbq_specs.main_burner_count', 'bbq_specs.side_burner_included', 'bbq_specs.rotisserie_included', 'bbq_specs.rear_burner_included', 'custom.sale_offer_name'];
        const metafieldFacets = (filterConfig?.metafieldFilters || [])
          .map(f => f?.filterKey)
          .filter(key => key && !key.startsWith('accentuate.') && !key.startsWith('general_specs.') && !key.startsWith('bbq_specs.'));
        const allFacets = [...baseFacets, ...metafieldFacets];
  
        // Extract price intent from natural language queries
        cleanedQuery = searchQuery;
        priceExtracted = null;
        const pricePatterns = [
          { regex: /\b(?:under|below|less than|cheaper than|max)\s*\$?(\d+)/i, type: 'max' },
          { regex: /\b(?:over|above|more than|min|at least)\s*\$?(\d+)/i, type: 'min' },
          { regex: /\b(?:between|\$?(\d+)\s*(?:to|-)\s*\$?(\d+))/i, type: 'range' },
          { regex: /\$(\d+)\s*(?:or less|and under|max)/i, type: 'max' },
          { regex: /\$(\d+)\s*(?:or more|and up|\+)/i, type: 'min' }
        ];
  
        for (const pattern of pricePatterns) {
          const match = cleanedQuery.match(pattern.regex);
          if (match) {
            if (pattern.type === 'max') {
              priceExtracted = { type: 'max', value: parseInt(match[1]) };
            } else if (pattern.type === 'min') {
              priceExtracted = { type: 'min', value: parseInt(match[1]) };
            } else if (pattern.type === 'range' && match[1] && match[2]) {
              priceExtracted = { type: 'range', min: parseInt(match[1]), max: parseInt(match[2]) };
            }
            cleanedQuery = cleanedQuery.replace(match[0], '').trim();
            cleanedQuery = cleanedQuery.replace(/\b(best|good|top|great|for|a)\b\s*/gi, '').replace(/\s+/g, ' ').trim();
            break;
          }
        }
  
        const meiliHeaders = {
          'Content-Type': 'application/json'
        };
        const meiliUrl = 'https://search.bbqing.com/api/proxy/search/shopify_content';
        const queryText = cleanedQuery || searchQuery;
        const useHybrid = queryText && queryText.trim().length > 0;
  
        showingAccessories = false;
  
        // Build search body — add price filter to Meilisearch filters
        if (priceExtracted) {
          if (priceExtracted.type === 'max') filters.push(`price <= ${priceExtracted.value}`);
          else if (priceExtracted.type === 'min') filters.push(`price >= ${priceExtracted.value}`);
          else if (priceExtracted.type === 'range') filters.push(`price >= ${priceExtracted.min} AND price <= ${priceExtracted.max}`);
          // Sync to price slider UI
          if (priceExtracted.type === 'max' || priceExtracted.type === 'range') {
            const maxEl = document.getElementById('price-max');
            if (maxEl) maxEl.value = priceExtracted.value || priceExtracted.max;
            currentFilters.priceMax = priceExtracted.value || priceExtracted.max;
          }
          if (priceExtracted.type === 'min' || priceExtracted.type === 'range') {
            const minEl = document.getElementById('price-min');
            if (minEl) minEl.value = priceExtracted.value || priceExtracted.min;
            currentFilters.priceMin = priceExtracted.value || priceExtracted.min;
          }
        }
  
        // Quick keyword check to avoid semantic results for garbage queries
        if (useHybrid && !loadMore) {
          const keywordCheck = await fetch(meiliUrl, {
            method: 'POST', headers: meiliHeaders,
            body: JSON.stringify({ q: queryText, filter: filters.join(' AND '), limit: 1, attributesToRetrieve: ['id'] })
          });
          const keywordRes = await keywordCheck.json();
          if ((keywordRes.estimatedTotalHits || 0) === 0) {
            // No keyword matches — show empty results, don't fall back to semantic
            allProducts = [];
            displayedProducts = [];
            showNoResults();
            buildFacets([]);
            return;
          }
        }
  
        // Detect accessory-intent queries — use keyword-only search for these
        const ACCESSORY_WORDS = ['brush', 'cover', 'thermometer', 'probe', 'glove', 'mitt', 'tong', 'tongs', 'spatula', 'fork', 'tool', 'tools', 'mat', 'pad', 'rack', 'grate', 'drip', 'igniter', 'burner', 'knob', 'handle', 'chip', 'chips', 'chunk', 'chunks', 'pellet', 'pellets', 'sauce', 'rub', 'seasoning', 'marinade', 'injector', 'basket', 'rotisserie', 'cable', 'adapter', 'regulator', 'hose', 'lighter', 'cleaner', 'scraper', 'apron', 'board', 'skewer', 'skewers', 'hook', 'shelf', 'wheel', 'caster', 'cart', 'bag', 'case', 'kit', 'set', 'wrap', 'foil', 'pan', 'plate', 'bucket', 'ash', 'grease', 'gasket', 'lump', 'charcoal', 'briquette', 'cookbook', 'book'];
        const queryWords = (queryText || '').toLowerCase().split(/\s+/);
        const isAccessoryIntent = queryWords.some(w => ACCESSORY_WORDS.some(aw => w === aw || w.startsWith(aw)));
  
        const searchBody = {
          q: queryText,
          filter: filters.join(' AND '),
          sort: sort.length > 0 ? sort : undefined,
          limit: productsPerPage,
          offset: loadMore ? currentPage * productsPerPage : 0,
          facets: allFacets,
          showRankingScore: true
        };
        // Accessory-intent queries use keyword-only search for precision
        // Other queries use hybrid search with moderate semantic ratio
        if (useHybrid && !isAccessoryIntent) searchBody.hybrid = { semanticRatio: 0.3, embedder: 'default' };
  
        DEBUG && console.log(`🔍 [SEARCH PAGE] Query: "${queryText}" | Hybrid: ${!!searchBody.hybrid} | AccessoryIntent: ${isAccessoryIntent} | Price: ${JSON.stringify(priceExtracted)} | Filters: ${filters.join(' AND ')}`);
        let searchRes = await fetch(meiliUrl, { method: 'POST', headers: meiliHeaders, body: JSON.stringify(searchBody) });
        let response = await searchRes.json();
  
        // Handle Meilisearch error responses (e.g., invalid facets, bad filters)
        if (response.message && !response.hits) {
          DEBUG && console.warn('⚠️ Meilisearch error:', response.message);
          // Retry without facets and hybrid as fallback
          const fallbackBody = { q: queryText, filter: filters.join(' AND '), sort: sort.length > 0 ? sort : undefined, limit: productsPerPage, offset: loadMore ? currentPage * productsPerPage : 0, facets: allFacets };
          searchRes = await fetch(meiliUrl, { method: 'POST', headers: meiliHeaders, body: JSON.stringify(fallbackBody) });
          response = await searchRes.json();
          if (response.message && !response.hits) {
            DEBUG && console.error('❌ Fallback also failed:', response.message);
            response = { hits: [], estimatedTotalHits: 0 };
          }
        }
  
        DEBUG && console.log(`🔍 [SEARCH PAGE] Hits: ${(response.hits || []).length} | Semantic: ${response.semanticHitCount} | Total: ${response.estimatedTotalHits}`);
  
        // If price-filtered search got 0 results, retry without price to show what's available
        if (priceExtracted && (response.hits || []).length === 0 && !loadMore) {
          const filtersNoPrice = filters.filter(f => !f.includes('price <=') && !f.includes('price >='));
          const retryBody = {
            q: queryText,
            filter: filtersNoPrice.join(' AND '),
            sort: ['price:asc'],
            limit: productsPerPage,
            offset: 0,
            facets: allFacets
          };
          if (useHybrid && !isAccessoryIntent) retryBody.hybrid = { semanticRatio: 0.3, embedder: 'default' };
  
          searchRes = await fetch(meiliUrl, { method: 'POST', headers: meiliHeaders, body: JSON.stringify(retryBody) });
          response = await searchRes.json();
  
          if ((response.hits || []).length > 0) {
            const cheapest = response.hits[0].price;
            const priceLabel = priceExtracted.type === 'max' ? `under $${priceExtracted.value}` : priceExtracted.type === 'min' ? `over $${priceExtracted.value}` : `between $${priceExtracted.min}–$${priceExtracted.max}`;
            showingAccessories = `No results ${priceLabel}. Prices start at <strong>$${cheapest.toLocaleString()}</strong>. Showing all matching products.`;
          }
        }
  
        DEBUG && console.log('✅ Search results:', response.hits.length, 'of', response.estimatedTotalHits);
  
        // Store facet distribution for accurate filter counts
        if (response.facetDistribution) {
          facetDistribution = response.facetDistribution;
        }
        totalEstimatedHits = response.estimatedTotalHits || response.hits.length;
  
        // Filter out low-relevance results (score < 0.6) to prevent irrelevant "load more" pages
        const MIN_RELEVANCE = 0.6;
        const relevantHits = response.hits.filter(h => (h._rankingScore || 1) >= MIN_RELEVANCE);
        const hitsBelowThreshold = response.hits.length - relevantHits.length;
        if (hitsBelowThreshold > 0) {
          DEBUG && console.log(`🎯 Filtered out ${hitsBelowThreshold} low-relevance results (score < ${MIN_RELEVANCE})`);
        }
  
        if (loadMore) {
          allProducts = [...allProducts, ...relevantHits];
          currentPage++;
        } else {
          allProducts = relevantHits;
          displayedProducts = allProducts;
        }
  
        // If most results in this batch were below threshold, stop offering load more
        reachedRelevanceFloor = hitsBelowThreshold > relevantHits.length;
  
        if (allProducts.length === 0) {
          showNoResults();
          buildFacets([]);
          return;
        }
  
        // buildFacets uses facetDistribution for accurate counts
        buildFacets(allProducts);

        // Preserve scroll position AND avoid visual glitch across Load More.
        // Reuse the live DOM nodes for cards already on screen instead of letting innerHTML
        // recreate them — this avoids re-triggered CSS transitions and image re-decoding,
        // which is what reads as a glitch.
        let anchor = null;
        let cardCache = null;
        if (loadMore && els.resultsGrid) {
          cardCache = new Map();
          for (const card of els.resultsGrid.querySelectorAll('.product-card[data-product-id]')) {
            cardCache.set(card.getAttribute('data-product-id'), card);
          }
          for (const card of cardCache.values()) {
            const r = card.getBoundingClientRect();
            if (r.bottom > 0) { anchor = { id: card.getAttribute('data-product-id'), top: r.top }; break; }
          }
        }
        displayResults(allProducts);
        if (cardCache && cardCache.size) {
          for (const newCard of els.resultsGrid.querySelectorAll('.product-card[data-product-id]')) {
            const cached = cardCache.get(newCard.getAttribute('data-product-id'));
            if (cached) newCard.replaceWith(cached);
          }
          console.log('🔒 [search loadMore] reused', cardCache.size, 'existing card DOM nodes');
        }
        if (anchor) {
          const restore = () => {
            const el = document.querySelector(`.product-card[data-product-id="${anchor.id}"]`);
            if (el) window.scrollBy(0, el.getBoundingClientRect().top - anchor.top);
          };
          restore();
          requestAnimationFrame(restore);
          setTimeout(restore, 300);
        }
        updateCompareBar();
        syncToURL();
  
        // Track search event
        if (!loadMore && window.MeiliAnalytics) {
          window.MeiliAnalytics.trackSearch(searchQuery, allProducts.length, 'search-page');
        }
  
        // Elevar dl_view_search_results — disabled, Elevar's SDK handles this automatically
  
        // Show load more button if there are more relevant results to fetch
        const loadMoreContainer = document.getElementById('load-more-container');
        const loadMoreBtn = document.getElementById('load-more-btn');
        const relevanceFloorMsg = document.getElementById('relevance-floor-msg');
        const remaining = totalEstimatedHits - (currentPage + 1) * productsPerPage;
        if (remaining > 0 && !reachedRelevanceFloor) {
          loadMoreContainer.style.display = 'block';
          loadMoreBtn.textContent = `Load More Products`;
          if (relevanceFloorMsg) relevanceFloorMsg.style.display = 'none';
        } else {
          loadMoreContainer.style.display = 'none';
          // Show "all relevant results" message if we cut off due to relevance (not because results ran out naturally)
          if (relevanceFloorMsg && reachedRelevanceFloor && allProducts.length > 0) {
            relevanceFloorMsg.style.display = 'block';
          } else if (relevanceFloorMsg) {
            relevanceFloorMsg.style.display = 'none';
          }
        }
  
      } catch (error) {
        DEBUG && console.error('❌ Search error:', error);
        showError(error);
      }
    }
  
    function buildFacets(products) {
      function getHexColor(colorName) {
        if (filterConfig?.colorHexCodes) {
          if (filterConfig.colorHexCodes[colorName]) return filterConfig.colorHexCodes[colorName];
          const configKey = Object.keys(filterConfig.colorHexCodes).find(key => key.toLowerCase() === colorName.toLowerCase());
          if (configKey) return filterConfig.colorHexCodes[configKey];
        }
        const colorMap = { 'black': '#000000', 'white': '#FFFFFF', 'red': '#DC2626', 'blue': '#2563EB', 'green': '#059669', 'yellow': '#EAB308', 'orange': '#EA580C', 'purple': '#9333EA', 'pink': '#EC4899', 'gray': '#6B7280', 'grey': '#6B7280', 'brown': '#92400E', 'navy': '#1E3A8A', 'silver': '#C0C0C0', 'gold': '#FFD700', 'beige': '#F5F5DC', 'stainless': '#C0C0C0', 'charcoal': '#36454F' };
        const lower = colorName.toLowerCase();
        if (colorMap[lower]) return colorMap[lower];
        for (const [key, value] of Object.entries(colorMap)) { if (lower.startsWith(key)) return value; }
        if (lower.includes('stainless')) return '#C0C0C0';
        return '#E5E7EB';
      }
  
      // Helper: render a standard checkbox list filter
      function renderCheckboxFilter(containerId, facetData, stateSet, filterType, sortFn, options) {
        const container = document.getElementById(containerId);
        const section = container?.closest('div[style*="margin-bottom"]');
        if (!container) return;
        const entries = Object.entries(facetData);
        if (entries.length === 0 || (options?.hideIfSingle && entries.length <= 1 && stateSet.size === 0)) { if (section) section.style.display = 'none'; return; }
        if (section) section.style.display = 'block';
        const sorted = sortFn ? entries.sort(sortFn) : entries.sort((a, b) => b[1] - a[1]);
        const showSearch = entries.length > 8;
        const searchHtml = showSearch ? `
          <div style="position: sticky; top: 0; background: #fff; padding: 0 0 8px 0; z-index: 1;">
            <input type="text" placeholder="Search..." class="filter-search-input" style="width: 100%; padding: 7px 10px; border: 1px solid #e0e0e0; border-radius: 6px; font-size: 13px; outline: none; box-sizing: border-box; color: #1a1a1a; transition: border-color 0.15s;" onfocus="this.style.borderColor='#999'" onblur="this.style.borderColor='#e0e0e0'">
          </div>
        ` : '';
        const displayLabel = (v) => v === 'true' ? 'Yes' : v === 'false' ? 'No' : v;
        const labelsHtml = sorted.map(([value, count]) => `
          <label style="display: flex; align-items: center; padding: 8px 6px; cursor: pointer; font-size: 14px; border-radius: 4px; margin: 0 -6px; transition: background 0.15s;" onmouseover="this.style.background='#f9fafb'" onmouseout="this.style.background='transparent'" data-filter-value="${escapeHtml(value.toLowerCase())}">
            <input type="checkbox" value="${escapeHtml(value)}" ${stateSet.has(value) ? 'checked' : ''} data-filter-type="${filterType}" class="filter-checkbox" style="margin-right: 10px; cursor: pointer; width: 17px; height: 17px; accent-color: #1a1a1a;">
            <span style="flex: 1; color: #1a1a1a; font-weight: 400;">${escapeHtml(displayLabel(value))}</span>
            <span style="color: #4b5563; font-size: 12px; font-weight: 400;">${count}</span>
          </label>
        `).join('');
        if (showSearch) {
          container.style.maxHeight = '320px';
          container.style.overflowY = 'auto';
          container.style.overflowX = 'hidden';
          container.style.paddingRight = '15px';
        } else {
          container.style.maxHeight = '';
          container.style.overflowY = '';
          container.style.overflowX = '';
          container.style.paddingRight = '';
        }
        container.innerHTML = searchHtml + labelsHtml;
        if (showSearch) {
          const searchInput = container.querySelector('.filter-search-input');
          searchInput.addEventListener('input', function() {
            const query = this.value.toLowerCase().trim();
            container.querySelectorAll('label[data-filter-value]').forEach(label => {
              label.style.display = !query || label.dataset.filterValue.includes(query) ? 'flex' : 'none';
            });
          });
        }
        container.querySelectorAll('input[type="checkbox"]').forEach(cb => cb.addEventListener('change', handleFilterChange));
      }

      // Current Offers — uses metafield filter pipeline (custom.sale_offer_name)
      function renderOffersFilter(facetData) {
        const block = document.getElementById('current-offers-block');
        const container = document.getElementById('current-offers-filter-options');
        if (!block || !container) return;

        const activeOffers = currentFilters.metafields['custom.sale_offer_name'] || new Set();
        const merged = { ...facetData };
        activeOffers.forEach(v => { if (!(v in merged)) merged[v] = 0; });
        const entries = Object.entries(merged);

        if (entries.length === 0) { block.style.display = 'none'; return; }
        block.style.display = 'block';

        // Sort: active checked first, then A-Z by offer name (locale-aware, case-insensitive).
        entries.sort((a, b) => {
          const aChecked = activeOffers.has(a[0]) ? 1 : 0;
          const bChecked = activeOffers.has(b[0]) ? 1 : 0;
          if (aChecked !== bChecked) return bChecked - aChecked;
          return a[0].localeCompare(b[0], undefined, { sensitivity: 'base' });
        });

        const INITIAL_LIMIT = 5;
        // Keep the toggle persistent across re-renders (e.g. when other filters apply)
        const expanded = container.dataset.offersExpanded === 'true';
        const hasMore = entries.length > INITIAL_LIMIT;

        const labelHtml = ([value, count]) => `
          <label style="display: flex; align-items: center; padding: 8px 6px; cursor: pointer; font-size: 14px; border-radius: 4px; margin: 0 -6px; transition: background 0.15s;" onmouseover="this.style.background='#f9fafb'" onmouseout="this.style.background='transparent'">
            <input type="checkbox" value="${escapeHtml(value)}" ${activeOffers.has(value) ? 'checked' : ''} data-filter-type="metafield" data-metafield-key="custom.sale_offer_name" class="filter-checkbox" style="margin-right: 10px; cursor: pointer; width: 17px; height: 17px; accent-color: #1a1a1a;">
            <span style="flex: 1; color: #1a1a1a; font-weight: 400;">${escapeHtml(value)}</span>
            <span style="color: #9ca3af; font-size: 12px; font-weight: 400;">${count}</span>
          </label>
        `;

        const visible = (hasMore && !expanded) ? entries.slice(0, INITIAL_LIMIT) : entries;
        const toggleBtn = hasMore
          ? `<button type="button" data-offers-toggle style="background: none; border: none; padding: 8px 6px; margin: 4px -6px 0; cursor: pointer; font-size: 13px; color: #1a1a1a; font-weight: 600; text-decoration: underline; display: block;">${expanded ? 'Show less' : `Show ${entries.length - INITIAL_LIMIT} more`}</button>`
          : '';

        container.innerHTML = visible.map(labelHtml).join('') + toggleBtn;

        container.querySelectorAll('input[type="checkbox"]').forEach(cb => cb.addEventListener('change', handleFilterChange));

        const btn = container.querySelector('[data-offers-toggle]');
        if (btn) {
          btn.addEventListener('click', () => {
            container.dataset.offersExpanded = expanded ? 'false' : 'true';
            renderOffersFilter(facetData);
          });
        }
      }

      // Numeric sort helper
      const numericSort = (a, b) => { const an = parseFloat(a[0]), bn = parseFloat(b[0]); return (!isNaN(an) && !isNaN(bn)) ? an - bn : a[0].localeCompare(b[0]); };
  
      // Build color families (a single color can match multiple families)
      let colorFamilies = {};
      const rawColors = facetDistribution?.color || {};
      Object.entries(rawColors).forEach(([color, count]) => {
        const families = getColorFamilies(color);
        families.forEach(family => { colorFamilies[family] = (colorFamilies[family] || 0) + count; });
      });
  
      // 0. Current Offers (custom.sale_offer_name) — rendered above all filters
      renderOffersFilter(facetDistribution?.['custom.sale_offer_name'] || {});

      // 1. Brand
      renderCheckboxFilter('brand-filter-options', facetDistribution?.vendor || {}, currentFilters.brands, 'brand', null, { hideIfSingle: true });
  
      // 2. Configuration
      renderCheckboxFilter('taxonomy-configuration-filter-options', facetDistribution?.taxonomy_configuration || {}, currentFilters.taxonomy.configuration, 'taxonomy-configuration', null, { hideIfSingle: true });
  
      // 3. Fuel Type
      renderCheckboxFilter('fuel-type-filter-options', facetDistribution?.fuel_type || {}, currentFilters.fuelTypes, 'fuel_type', null, { hideIfSingle: true });
  
      // 4. Product Type
      renderCheckboxFilter('type-filter-options', facetDistribution?.taxonomy_category || {}, currentFilters.types, 'type', null, { hideIfSingle: true });
  
      // 5. Price - handled by price slider (no checkbox list)
  
      // 6. Series
      renderCheckboxFilter('series-filter-options', facetDistribution?.['general_specs.series'] || {}, currentFilters.series, 'series', null, { hideIfSingle: true });
  
      // 7. Main Burners
      renderCheckboxFilter('main-burners-filter-options', facetDistribution?.['bbq_specs.main_burner_count'] || {}, currentFilters.mainBurners, 'main-burners', numericSort, { hideIfSingle: true });
  
      // 8. Side Burners
      renderCheckboxFilter('side-burners-filter-options', facetDistribution?.['bbq_specs.side_burner_included'] || {}, currentFilters.sideBurners, 'side-burners', null, { hideIfSingle: true });
  
      // 9. Rear/Rotisserie Burner - combine two fields into one facet display
      const rrData = {};
      const rotisserie = facetDistribution?.['bbq_specs.rotisserie_included'] || {};
      const rearBurner = facetDistribution?.['bbq_specs.rear_burner_included'] || {};
      Object.entries(rotisserie).forEach(([v, c]) => { rrData[v] = (rrData[v] || 0) + c; });
      Object.entries(rearBurner).forEach(([v, c]) => { rrData[v] = (rrData[v] || 0) + c; });
      renderCheckboxFilter('rear-rotisserie-filter-options', rrData, currentFilters.rearRotisserie, 'rear-rotisserie', null, { hideIfSingle: true });
  
      // 10. Color (swatches)
      const colorContainer = document.getElementById('color-filter-options');
      const colorSection = colorContainer?.closest('div[style*="margin-bottom"]');
      if (colorContainer) {
        if (Object.keys(colorFamilies).length === 0) {
          if (colorSection) colorSection.style.display = 'none';
        } else {
          if (colorSection) colorSection.style.display = 'block';
          colorContainer.innerHTML = `<div style="display: grid; grid-template-columns: 1fr 1fr; gap: 12px;">
            ${Object.entries(colorFamilies).sort((a, b) => b[1] - a[1]).map(([family, count]) => {
              const hexColor = getHexColor(family);
              const borderColor = family.toLowerCase().includes('white') ? '#d1d5db' : hexColor;
              const safeFamily = escapeHtml(family);
              return `<label style="display: flex; align-items: center; gap: 8px; cursor: pointer; font-size: 13px;" onmouseover="this.style.opacity='0.7'" onmouseout="this.style.opacity='1'">
                <input type="checkbox" value="${safeFamily}" ${currentFilters.colors.has(family) ? 'checked' : ''} data-filter-type="color" class="filter-checkbox" style="display: none;" aria-label="Filter by color: ${safeFamily}">
                <div style="width: 20px; height: 20px; border-radius: 50%; background: ${hexColor}; border: 2px solid ${borderColor}; flex-shrink: 0; box-shadow: 0 0 0 1px rgba(0,0,0,0.1);"></div>
                <span style="color: #1a1a1a; font-weight: 400; flex: 1;">${safeFamily}</span>
                <span style="color: #4b5563; font-size: 12px; font-weight: 400;">${count}</span>
              </label>`;
            }).join('')}
          </div>`;
          colorContainer.querySelectorAll('input').forEach(cb => cb.addEventListener('change', handleFilterChange));
        }
      }
  
      // Remove border from last visible filter
      const filterContainer = document.getElementById('dynamic-filters-container');
      if (filterContainer) {
        const allFilters = filterContainer.querySelectorAll(':scope > div');
        allFilters.forEach(f => f.classList.remove('last-visible-filter'));
        const visible = Array.from(allFilters).filter(f => f.style.display !== 'none');
        if (visible.length > 0) {
          visible[visible.length - 1].classList.add('last-visible-filter');
        }
      }
    }
  
    // Group variants into single product containers
    // Group variants by handle + color (separate card per color)
    function groupProductsByHandle(products) {
      const grouped = {};
  
      for (const product of products) {
        const urlMatch = product.url?.match(/\/products\/([^?#\/]+)/);
        const handle = urlMatch ? urlMatch[1] : product.id;
  
        // Determine this variant's color value
        let variantColor = null;
        const hasAnyOption = product.option1_name || product.option2_name || product.option3_name;
        if (hasAnyOption) {
          for (let i = 1; i <= 3; i++) {
            const optName = product[`option${i}_name`];
            const optVal = product[`option${i}_value`];
            if (!optName || !optVal) continue;
            if (optName === 'Title' && optVal === 'Default Title') continue;
            const key = optName.toLowerCase();
            if (key === 'color' || key === 'colour') {
              variantColor = optVal;
              break;
            }
          }
        } else if (product.color) {
          variantColor = product.color;
        }
  
        // Group by handle only — one card per product (color variants merged)
        const groupKey = handle;
  
        const thirtyDaysAgo = Date.now() - (30 * 24 * 60 * 60 * 1000);
        const isNew = product.published_at && product.published_at >= thirtyDaysAgo;
        const isCanadian = product.tags && product.tags.includes('Canadian Brand');
        const isGwp = hasGwpPromo(product.tags);
  
        if (!grouped[groupKey]) {
          grouped[groupKey] = {
            main: product,
            variants: [product],
            colorName: variantColor,
            lowestPrice: product.price,
            hasOnSale: product.compare_at_price > product.price && product.price > 0,
            isNewArrival: isNew,
            isCanadian: isCanadian,
            hasGwpPromo: isGwp,
            hasPromo: product['custom.offer_type'] === 'Promotions'
          };
        } else {
          grouped[groupKey].variants.push(product);
          if (product.price < grouped[groupKey].lowestPrice) {
            grouped[groupKey].lowestPrice = product.price;
          }
          if (product.compare_at_price > product.price && product.price > 0) {
            grouped[groupKey].hasOnSale = true;
          }
          if (isNew) {
            grouped[groupKey].isNewArrival = true;
          }
          if (isCanadian) {
            grouped[groupKey].isCanadian = true;
          }
          if (isGwp) {
            grouped[groupKey].hasGwpPromo = true;
          }
          if (product['custom.offer_type'] === 'Promotions') {
            grouped[groupKey].hasPromo = true;
          }
        }
      }
  
      // Preserve original order: return groups in the order their first product appeared
      const orderedKeys = [];
      const seen = new Set();
      for (const product of products) {
        const urlMatch = product.url?.match(/\/products\/([^?#\/]+)/);
        const handle = urlMatch ? urlMatch[1] : product.id;
        let variantColor = null;
        if (product.option1_name || product.option2_name || product.option3_name) {
          for (let i = 1; i <= 3; i++) {
            const optName = product[`option${i}_name`];
            const optVal = product[`option${i}_value`];
            if (!optName || !optVal) continue;
            if (optName === 'Title' && optVal === 'Default Title') continue;
            if (optName.toLowerCase() === 'color' || optName.toLowerCase() === 'colour') { variantColor = optVal; break; }
          }
        } else if (product.color) { variantColor = product.color; }
        const groupKey = handle;
        if (!seen.has(groupKey)) { seen.add(groupKey); orderedKeys.push(groupKey); }
      }
      return orderedKeys.map(k => grouped[k]).filter(Boolean);
    }
  
    function displayResults(products) {
      DEBUG && console.log('📦 Displaying products:', products.length);
      // Debug: Log first product to see available fields
      if (products.length > 0) {
        DEBUG && console.log('🔍 Sample product fields:', Object.keys(products[0]));
        DEBUG && console.log('🔍 Sample product data:', products[0]);
      }
      hideLoading();
      setNoResultsMode(false);
      els.noResults.style.display = 'none';
      els.resultsHeader.style.display = 'block';

      // Group products by handle + color (one card per color)
      const groupedProducts = groupProductsByHandle(products);
  
      // Re-sort grouped products to maintain sort order after grouping
      if (currentSort === 'price-asc') {
        groupedProducts.sort((a, b) => a.lowestPrice - b.lowestPrice);
      } else if (currentSort === 'price-desc') {
        groupedProducts.sort((a, b) => b.lowestPrice - a.lowestPrice);
      } else if (currentSort === 'newest') {
        groupedProducts.sort((a, b) => (b.main.created_at || 0) - (a.main.created_at || 0));
      } else if (currentSort === 'oldest') {
        groupedProducts.sort((a, b) => (a.main.created_at || 0) - (b.main.created_at || 0));
      }
  
      // Count how many color groups each base handle has
      const handleColorCount = {};
      for (const group of groupedProducts) {
        const h = group.main.url?.match(/\/products\/([^?#\/]+)/)?.[1] || group.main.id;
        handleColorCount[h] = (handleColorCount[h] || 0) + 1;
      }
      // Tag each group so we know whether to show color in title
      for (const group of groupedProducts) {
        const h = group.main.url?.match(/\/products\/([^?#\/]+)/)?.[1] || group.main.id;
        group.showColorInTitle = handleColorCount[h] > 1;
      }
  
      DEBUG && console.log('📦 Grouped into', groupedProducts.length, 'unique products');
  
      // Show the number of products actually displayed on the page
      const displayTotal = groupedProducts.length;
      let searchNote = '';
      if (showingAccessories && typeof showingAccessories === 'string') {
        // Price mismatch — showing relevant products but outside requested price
        searchNote = `<div style="margin-top: 12px; padding: 14px 20px; background: #eef6ff; border-radius: 8px; font-size: 14px; color: #1e40af; line-height: 1.5;">${showingAccessories}</div>`;
      } else if (showingAccessories) {
        // No relevant products at all
        searchNote = `<div style="margin-top: 12px; padding: 14px 20px; background: #fef3c7; border-radius: 8px; font-size: 14px; color: #92400e; line-height: 1.5;">No exact matches found. Try different search terms.</div>`;
      }
      els.resultsCount.innerHTML = `<span style="font-weight: 600;">${searchQuery}</span> <span style="color: #666; font-weight: 400;">${displayTotal} products</span>${searchNote}`;
  
      // Update mobile product count
      const mobileCount = document.getElementById('mobile-product-count');
      if (mobileCount) {
        mobileCount.textContent = `${displayTotal} Products`;
      }
  
      // Update mobile view products button
      const viewProductsBtn = document.getElementById('view-products-btn');
      if (viewProductsBtn) {
        viewProductsBtn.textContent = `VIEW ${displayTotal} PRODUCTS`;
      }
  
      // Helper function to get hex color
      function getProductHexColor(colorName) {
        if (!colorName) return '#E5E7EB';
        if (filterConfig?.colorHexCodes) {
          if (filterConfig.colorHexCodes[colorName]) {
            return filterConfig.colorHexCodes[colorName];
          }
          const configKey = Object.keys(filterConfig.colorHexCodes).find(
            key => key.toLowerCase() === colorName.toLowerCase()
          );
          if (configKey) {
            return filterConfig.colorHexCodes[configKey];
          }
        }
        const colorMap = {
          'black': '#000000', 'white': '#FFFFFF', 'red': '#DC2626', 'blue': '#2563EB',
          'green': '#059669', 'yellow': '#EAB308', 'orange': '#EA580C', 'purple': '#9333EA',
          'pink': '#EC4899', 'gray': '#6B7280', 'grey': '#6B7280', 'brown': '#92400E',
          'navy': '#1E3A8A', 'silver': '#C0C0C0', 'gold': '#FFD700', 'beige': '#F5F5DC',
          'stainless': '#C0C0C0', 'charcoal': '#36454F'
        };
        const lower = colorName.toLowerCase();
        if (colorMap[lower]) return colorMap[lower];
        for (const [key, value] of Object.entries(colorMap)) {
          if (lower.includes(key)) return value;
        }
        return '#E5E7EB';
      }
  
      DEBUG && console.log('🐛 DEBUG: About to render grid. resultsGrid element:', els.resultsGrid);
      DEBUG && console.log('🐛 DEBUG: resultsGrid parent:', els.resultsGrid?.parentElement);
      DEBUG && console.log('🐛 DEBUG: resultsGrid display:', window.getComputedStyle(els.resultsGrid).display);
      DEBUG && console.log('🐛 DEBUG: resultsGrid visibility:', window.getComputedStyle(els.resultsGrid).visibility);
      DEBUG && console.log('🐛 DEBUG: resultsGrid height:', window.getComputedStyle(els.resultsGrid).height);
      DEBUG && console.log('🐛 DEBUG: resultsGrid overflow:', window.getComputedStyle(els.resultsGrid).overflow);
      DEBUG && console.log('🐛 DEBUG: resultsGrid parent display:', window.getComputedStyle(els.resultsGrid.parentElement).display);
      DEBUG && console.log('🐛 DEBUG: resultsGrid parent height:', window.getComputedStyle(els.resultsGrid.parentElement).height);
      DEBUG && console.log('🐛 DEBUG: resultsGrid parent overflow:', window.getComputedStyle(els.resultsGrid.parentElement).overflow);
      DEBUG && console.log('🐛 DEBUG: resultsGrid parent visibility:', window.getComputedStyle(els.resultsGrid.parentElement).visibility);
      DEBUG && console.log('🐛 DEBUG: #search-container display:', window.getComputedStyle(document.getElementById('search-container')).display);
      DEBUG && console.log('🐛 DEBUG: #search-container gridTemplateColumns:', window.getComputedStyle(document.getElementById('search-container')).gridTemplateColumns);
      DEBUG && console.log('🐛 DEBUG: window.innerWidth:', window.innerWidth);
  
      try {
      els.resultsGrid.innerHTML = groupedProducts.map((group, index) => {
        const product = group.main;
        const imageUrl = escapeHtml(product.image_url || '');
        const vendor = escapeHtml(product.vendor || '');
        const safeTitle = escapeHtml(product.title || '');
        const safeSku = escapeHtml(product.sku || product.variant_sku || '');
        // LCP optimization: First 4 images get high priority
        const isAboveFold = index < 4;
        const imgPriority = isAboveFold ? 'fetchpriority="high" loading="eager"' : 'loading="lazy" decoding="async"';
  
        // Price display — "Starting from" using lowest price in the group
        const lowestPrice = group.lowestPrice;
        const hasMultipleVariants = group.variants.length > 1;
  
        let priceHTML = '';
        if (lowestPrice > 0) {
          if (hasMultipleVariants) {
            priceHTML = `<span style="font-size: 12px; font-weight: 400; color: #666;">Starting from</span> <span class="current-price" style="font-size: 18px; font-weight: 700; color: #1a1a1a;">$${formatPrice(lowestPrice)}</span>`;
          } else if (product.compare_at_price && product.compare_at_price > product.price && product.price > 0) {
            priceHTML = `
              <span class="current-price" style="font-size: 18px; font-weight: 700; color: #dc2626;">$${formatPrice(product.price)}</span>
              <span class="compare-price" style="font-size: 14px; color: #9ca3af; text-decoration: line-through; margin-left: 4px;">$${formatPrice(product.compare_at_price)}</span>
            `;
          } else {
            priceHTML = `<span class="current-price" style="font-size: 18px; font-weight: 700; color: #1a1a1a;">$${formatPrice(product.price)}</span>`;
          }
        }
  
        // Affirm "as low as" line (only for products $100+)
        const affirmPrice = hasMultipleVariants ? lowestPrice : product.price;
        const affirmCents = Math.round(affirmPrice * 100);
        const affirmHTML = affirmPrice >= 100 ? `
          <div style="margin-top: 6px;">
            <p class="affirm-as-low-as" data-page-type="product" data-amount="${affirmCents}" style="margin: 0; font-size: 12px; color: #666;">As low as...</p>
          </div>
        ` : '';
  
        const isInCompare = compareProducts.has(product.id);
        const productHandle = product.url?.match(/\/products\/([^?#\/]+)/)?.[1] || product.id;
  
        // Color suffix for title (e.g. " - Black") — only when multiple colors exist
        let colorSuffix = '';
        if (group.colorName && group.showColorInTitle) {
          colorSuffix = ` - ${group.colorName}`;
        }
  
        // SKU line
        const skuHTML = safeSku ? `<div style="font-size: 12px; color: #4b5563; margin-top: 6px;">SKU: ${safeSku}</div>` : '';
  
        // Product URL without variant query params
        const productUrl = product.url ? escapeHtml(product.url.split('?')[0]) : '#';
  
        return `
          <div class="product-card${isInCompare ? ' product-card--comparing' : ''}" data-handle="${productHandle}" data-product-id="${product.id}" style="position: relative; background: white; border: 1px solid ${isInCompare ? '#1a1a1a' : '#e5e7eb'}; border-radius: 4px; overflow: hidden; transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease; box-shadow: ${isInCompare ? '0 0 0 1px #1a1a1a' : '0 1px 3px rgba(0,0,0,0.06)'}; display: flex; flex-direction: column;">
  
            <button onclick="event.preventDefault(); showQuickView('${product.id}')" style="position: absolute; top: ${group.isCanadian ? '48px' : '8px'}; right: 8px; background: white; border: none; border-radius: 50%; width: 36px; height: 36px; cursor: pointer; display: flex; align-items: center; justify-content: center; box-shadow: 0 2px 8px rgba(0,0,0,0.1); opacity: 0; transition: opacity 0.2s; z-index: 1;" class="quick-view-btn product-icon-btn" data-tooltip="Quick View">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                <circle cx="12" cy="12" r="3"></circle>
              </svg>
              <span class="icon-tooltip">Quick View</span>
            </button>
  
            <a href="${productUrl}"
               onclick="trackProductView('${product.id}'); if(window.MeiliAnalytics) MeiliAnalytics.trackClick('${escapeHtml(searchQuery)}', '${product.id}', '${safeTitle}', ${index + 1}, 'search-page');"
               style="text-decoration: none; color: inherit; display: flex; flex-direction: column; flex: 1;">
              <div style="position: relative; background: white; overflow: hidden; padding: 5px;">
                ${group.hasOnSale ? `
                  <div style="position: absolute; top: 10px; left: 10px; background: #dc2626; color: white; padding: 4px 10px; border-radius: 4px; font-size: 12px; font-weight: 600; letter-spacing: 0.5px; z-index: 1;">SALE</div>
                ` : ''}
                ${group.isNewArrival ? `
                  <div style="position: absolute; top: ${group.hasOnSale ? '40px' : '10px'}; left: 10px; background: #2563eb; color: white; padding: 4px 10px; border-radius: 4px; font-size: 12px; font-weight: 600; letter-spacing: 0.5px; z-index: 1;">NEW</div>
                ` : ''}
                ${group.hasGwpPromo ? `
                  <div style="position: absolute; top: ${group.hasOnSale && group.isNewArrival ? '70px' : group.hasOnSale || group.isNewArrival ? '40px' : '10px'}; left: 10px; background: #059669; color: white; padding: 4px 10px; border-radius: 4px; font-size: 12px; font-weight: 600; letter-spacing: 0.5px; z-index: 1;">FREE GIFT</div>
                ` : ''}
                ${group.hasPromo && !group.hasOnSale && !group.hasGwpPromo ? `
                  <div style="position: absolute; top: ${group.isNewArrival ? '40px' : '10px'}; left: 10px; background: #2563eb; color: white; padding: 4px 10px; border-radius: 4px; font-size: 12px; font-weight: 600; letter-spacing: 0.5px; z-index: 1;">PROMO</div>
                ` : ''}
                ${group.isCanadian ? `
                  <div style="position: absolute; top: 10px; right: 10px; z-index: 1;" title="Canadian Brand">
                    <svg width="28" height="28" viewBox="0 0 512 512" fill="#dc2626"><path d="M383.8 351.7c2.5-2.5 105.2-92.4 105.2-92.4l-17.5-7.5c-10-4.9-7.4-11.5-5-17.4 2.4-7.6 20.1-67.3 20.1-67.3s-47.7 10-57.7 12.5c-7.5 2.4-10-2.5-12.5-7.5s-15-32.4-15-32.4-52.6 59.9-55.1 62.3c-10 7.5-20.1 0-17.6-10 0-10 27.6-129.6 27.6-129.6s-30.1 17.4-40.1 22.4c-7.5 5-12.6 5-17.6-5C293.5 72.3 255.9 0 255.9 0s-37.5 72.3-42.5 79.8c-5 10-10 10-17.6 5-10-5-40.1-22.4-40.1-22.4S183.3 182 183.3 192c2.5 10-7.5 17.5-17.6 10-2.5-2.5-55.1-62.3-55.1-62.3S98.1 167 95.6 172s-5 9.9-12.5 7.5C73 177 25.4 167 25.4 167s17.6 59.7 20.1 67.3c2.4 6 5 12.5-5 17.4L23 259.3s102.6 89.9 105.2 92.4c5.1 5 10 7.5 5.1 22.5-5.1 15-10.1 35.1-10.1 35.1s95.2-20.1 105.3-22.6c8.7-.9 18.3 2.5 18.3 12.5S241 512 241 512h30s-5.8-102.7-5.8-112.8 9.5-13.4 18.4-12.5c10 2.5 105.2 22.6 105.2 22.6s-5-20.1-10-35.1 0-17.5 5-22.5z"/></svg>
                  </div>
                ` : ''}
                ${imageUrl ? `
                  <img src="${escapeHtml(shopifyImageUrl(imageUrl, 300))}"
                       srcset="${shopifyImageSrcset(imageUrl, [200, 300, 450])}"
                       sizes="(max-width: 479px) 45vw, (max-width: 767px) 30vw, 25vw"
                       alt="${safeTitle}" width="300" height="300" ${imgPriority}
                       style="width: 100%; height: auto; display: block; aspect-ratio: 1; object-fit: contain;" class="product-card-image">
                ` : `
                  <div style="width: 100%; aspect-ratio: 1; background: #f5f5f5; display: flex; align-items: center; justify-content: center; color: #ddd; font-size: 14px;">No image</div>
                `}
              </div>
              <div class="product-card-content" style="padding: 14px 14px 8px;">
                ${vendor ? `<div style="font-size: 10px; color: #4b5563; text-transform: uppercase; letter-spacing: 1.2px; margin-bottom: 4px; font-weight: 600;">${vendor}</div>` : ''}
                <h3 style="font-size: 13px; font-weight: 600; line-height: 1.4; margin: 0; color: #111;">${safeTitle}${escapeHtml(colorSuffix)}</h3>
                ${skuHTML}
                <div class="product-price-display" style="margin-top: 8px; font-size: 18px; font-weight: 700; color: #1a1a1a;">${priceHTML}</div>
                ${affirmHTML}
              </div>
            </a>
            ${product.tags && product.tags.includes('dept_bbqs-smokers') ? `<div class="compare-btn-wrap" style="padding: 14px; border-top: 1px solid #e5e7eb;">
              <button type="button" onclick="event.preventDefault(); event.stopPropagation(); toggleCompare('${product.id}', ${!isInCompare})" aria-pressed="${isInCompare}" style="display: inline-flex; align-items: center; gap: 8px; background: none; border: none; padding: 0; cursor: pointer; font-size: 14px; color: #1a1a1a; font-weight: 700; text-decoration: none; transition: color 0.15s; line-height: 1;">
                <span aria-hidden="true" style="display: inline-flex; align-items: center; justify-content: center; width: 16px; height: 16px; flex-shrink: 0;">
                  ${isInCompare
                    ? '<svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="#1a1a1a" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="3,8 7,12 13,4"/></svg>'
                    : '<svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="#1a1a1a" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="8" y1="3" x2="8" y2="13"/><line x1="3" y1="8" x2="13" y2="8"/></svg>'
                  }
                </span>
                ${isInCompare ? 'Added to compare' : 'Add to compare'}
              </button>
            </div>` : ''}
          </div>
        `;
      }).join('');
  
      DEBUG && console.log('🐛 DEBUG: Grid innerHTML length after render:', els.resultsGrid.innerHTML.length);
      DEBUG && console.log('🐛 DEBUG: Grid childElementCount:', els.resultsGrid.childElementCount);
      DEBUG && console.log('🐛 DEBUG: Grid offsetHeight:', els.resultsGrid.offsetHeight);
      DEBUG && console.log('🐛 DEBUG: Grid scrollHeight:', els.resultsGrid.scrollHeight);
      DEBUG && console.log('🐛 DEBUG: Grid getBoundingClientRect:', JSON.stringify(els.resultsGrid.getBoundingClientRect()));
      DEBUG && console.log('🐛 DEBUG: First child rect:', els.resultsGrid.firstElementChild ? JSON.stringify(els.resultsGrid.firstElementChild.getBoundingClientRect()) : 'no children');
  
      } catch(err) {
        DEBUG && console.error('🐛 DEBUG: ERROR in grid render:', err.message, err.stack);
      }
  
      // Refresh Affirm promos on dynamically rendered cards
      if (typeof affirm !== 'undefined' && affirm.ui && affirm.ui.refresh) {
        affirm.ui.refresh();
      }
  
      DEBUG && console.log('✅ Products rendered');
    }
  
    function handleFilterChange(e) {
      const filterType = e.target.dataset.filterType;
      const value = e.target.value;
      const checked = e.target.checked;
  
      if (filterType === 'quick') {
        if (value === 'new-arrival') currentFilters.newArrival = checked;
        else if (value === 'promotion') currentFilters.promotion = checked;
        else if (value === 'clearance') currentFilters.clearance = checked;
        else if (value === 'canadian-brands') currentFilters.canadianBrands = checked;
      } else if (filterType === 'brand') {
        checked ? currentFilters.brands.add(value) : currentFilters.brands.delete(value);
      } else if (filterType === 'taxonomy-configuration') {
        checked ? currentFilters.taxonomy.configuration.add(value) : currentFilters.taxonomy.configuration.delete(value);
      } else if (filterType === 'fuel_type') {
        checked ? currentFilters.fuelTypes.add(value) : currentFilters.fuelTypes.delete(value);
      } else if (filterType === 'type') {
        checked ? currentFilters.types.add(value) : currentFilters.types.delete(value);
      } else if (filterType === 'color') {
        checked ? currentFilters.colors.add(value) : currentFilters.colors.delete(value);
      } else if (filterType === 'series') {
        checked ? currentFilters.series.add(value) : currentFilters.series.delete(value);
      } else if (filterType === 'main-burners') {
        checked ? currentFilters.mainBurners.add(value) : currentFilters.mainBurners.delete(value);
      } else if (filterType === 'side-burners') {
        checked ? currentFilters.sideBurners.add(value) : currentFilters.sideBurners.delete(value);
      } else if (filterType === 'rear-rotisserie') {
        checked ? currentFilters.rearRotisserie.add(value) : currentFilters.rearRotisserie.delete(value);
      } else if (filterType === 'metafield') {
        const metafieldKey = e.target.dataset.metafieldKey;
        if (!currentFilters.metafields[metafieldKey]) currentFilters.metafields[metafieldKey] = new Set();
        checked ? currentFilters.metafields[metafieldKey].add(value) : currentFilters.metafields[metafieldKey].delete(value);
      }
  
      updateClearButton();
      currentPage = 1;
      performSearch();
    }
  
    window.loadMore = function() {
      performSearch(true);
    };
  
    // Handle color swatch click - switch card image
    window.switchCardColor = function(swatch, imageUrl) {
      const card = swatch.closest('.product-card');
      if (!card) return;
      if (imageUrl) {
        const img = card.querySelector('.product-card-image');
        if (img) { img.src = imageUrl; }
      }
      card.querySelectorAll('.color-swatch').forEach(s => {
        s.classList.remove('active');
        s.style.boxShadow = 'none';
      });
      swatch.classList.add('active');
      swatch.style.boxShadow = '0 0 0 2px white, 0 0 0 3.5px #1a1a1a';
    };
  
    // Handle variant option selection (fuel type, material, size, color pills)
    window.selectVariantOption = function(btn, productHandle, optionType, optionValue) {
      // Find the product card
      const card = btn.closest('.product-card');
      if (!card) return;
  
      // Update visual state only for buttons of the SAME option type
      const isColorSwatch = optionType === 'color';
  
      if (isColorSwatch) {
        // Color swatches - update ring styling (only color swatches) - blue to match pills
        card.querySelectorAll('.variant-swatch').forEach(swatch => {
          const isSelected = swatch === btn;
          const color = swatch.dataset.optionValue;
          const isLightColor = ['white', 'beige', 'cream', 'ivory', 'silver'].some(c => color?.toLowerCase().includes(c));
          swatch.style.border = isSelected ? '2px solid #1a1a1a' : `2px solid ${isLightColor ? '#d1d5db' : 'transparent'}`;
          swatch.style.boxShadow = isSelected ? '0 0 0 2px #fff, 0 0 0 3px #1a1a1a' : 'none';
          swatch.classList.toggle('selected', isSelected);
        });
      } else {
        // Pills - update only pills of the same option type
        card.querySelectorAll(`.variant-pill[data-option-type="${optionType}"]`).forEach(pill => {
          const isSelected = pill === btn;
          pill.style.background = '#fff';
          pill.style.color = '#374151';
          pill.style.borderColor = isSelected ? '#1a1a1a' : '#d1d5db';
          pill.classList.toggle('selected', isSelected);
        });
      }
  
      // Get all selected options for this product (collect from all selected buttons)
      const selectedOptions = {};
      card.querySelectorAll('.variant-pill.selected, .variant-swatch.selected').forEach(selectedBtn => {
        const type = selectedBtn.dataset.optionType;
        if (type) {
          selectedOptions[type] = selectedBtn.dataset.optionValue;
        }
      });
  
      DEBUG && console.log('Selected options for', productHandle, ':', selectedOptions);
  
      // Get variants data from card
      const variantsJSON = card.dataset.variants;
      if (!variantsJSON) return;
  
      try {
        const variants = JSON.parse(variantsJSON.replace(/&quot;/g, '"'));
  
        // Find the best matching variant based on selected options
        let bestMatch = null;
        let bestMatchScore = -1;
  
        variants.forEach(variant => {
          let score = 0;
          let matches = true;
  
          // Check each selected option
          Object.keys(selectedOptions).forEach(optType => {
            const selectedValue = selectedOptions[optType];
            const variantValue = variant[optType];
  
            if (variantValue && selectedValue) {
              if (variantValue.toLowerCase() === selectedValue.toLowerCase()) {
                score++;
              } else {
                // If variant has this option but it doesn't match, it's not a match
                matches = false;
              }
            }
          });
  
          if (matches && score > bestMatchScore) {
            bestMatchScore = score;
            bestMatch = variant;
          }
        });
  
        // If no exact match, use first variant with matching primary option
        if (!bestMatch && variants.length > 0) {
          bestMatch = variants.find(v => {
            const primaryOption = Object.keys(selectedOptions)[0];
            return v[primaryOption]?.toLowerCase() === selectedOptions[primaryOption]?.toLowerCase();
          }) || variants[0];
        }
  
        // Update price display
        if (bestMatch) {
          const priceDisplay = card.querySelector('.product-price-display');
          if (priceDisplay) {
            const currentPriceEl = priceDisplay.querySelector('.current-price');
            const comparePriceEl = priceDisplay.querySelector('.compare-price');
            const isOnSale = bestMatch.compare_at_price && bestMatch.compare_at_price > bestMatch.price;
  
            if (currentPriceEl) {
              currentPriceEl.textContent = '$' + bestMatch.price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
              currentPriceEl.style.color = isOnSale ? '#dc2626' : '#000';
            }
  
            if (isOnSale) {
              if (comparePriceEl) {
                comparePriceEl.textContent = '$' + bestMatch.compare_at_price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                comparePriceEl.style.display = '';
              } else {
                // Add compare price element if it doesn't exist
                const compareSpan = document.createElement('span');
                compareSpan.className = 'compare-price';
                compareSpan.style.cssText = 'font-size: 14px; color: #9ca3af; text-decoration: line-through; margin-left: 8px;';
                compareSpan.textContent = '$' + bestMatch.compare_at_price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                priceDisplay.appendChild(compareSpan);
              }
            } else if (comparePriceEl) {
              comparePriceEl.style.display = 'none';
            }
          }
  
          // Update product image
          if (bestMatch.image_url) {
            const img = card.querySelector('.product-card-image');
            if (img) {
              img.src = bestMatch.image_url;
              img.alt = bestMatch.id;
            }
          }
  
          DEBUG && console.log('Matched variant:', bestMatch);
        }
      } catch (e) {
        DEBUG && console.error('Error parsing variants:', e);
      }
    };
  
    function updateClearButton() {
      const hasMetafieldFilters = Object.values(currentFilters.metafields).some(set => set && set.size > 0);
      const hasFilters = currentFilters.brands.size > 0 || currentFilters.types.size > 0 || currentFilters.colors.size > 0 || currentFilters.fuelTypes.size > 0 || currentFilters.taxonomy.configuration.size > 0 || currentFilters.series.size > 0 || currentFilters.mainBurners.size > 0 || currentFilters.sideBurners.size > 0 || currentFilters.rearRotisserie.size > 0 || currentFilters.priceMin !== null || currentFilters.priceMax !== null || currentFilters.newArrival || currentFilters.promotion || currentFilters.clearance || currentFilters.canadianBrands || hasMetafieldFilters;
      els.clearAll.style.display = hasFilters ? 'block' : 'none';
      updateActiveFilterPills();
    }
  
    function updateActiveFilterPills() {
      const pills = [];
  
      if (currentFilters.newArrival) pills.push({ type: 'new-arrival', value: 'true', label: 'New Arrivals' });
      if (currentFilters.promotion) pills.push({ type: 'promotion', value: 'true', label: 'Promotion' });
      if (currentFilters.clearance) pills.push({ type: 'clearance', value: 'true', label: 'Clearance' });
      if (currentFilters.canadianBrands) pills.push({ type: 'canadian-brands', value: 'true', label: 'Canadian Brands' });
  
      currentFilters.brands.forEach(brand => pills.push({ type: 'brand', value: brand, label: brand }));
      currentFilters.taxonomy.configuration.forEach(v => pills.push({ type: 'taxonomy-configuration', value: v, label: `Config: ${v}` }));
      currentFilters.fuelTypes.forEach(f => pills.push({ type: 'fuel_type', value: f, label: `Fuel: ${f}` }));
      currentFilters.types.forEach(type => pills.push({ type: 'type', value: type, label: type }));
      currentFilters.series.forEach(s => pills.push({ type: 'series', value: s, label: `Series: ${s}` }));
      currentFilters.mainBurners.forEach(m => pills.push({ type: 'main-burners', value: m, label: `Main Burners: ${m}` }));
      currentFilters.sideBurners.forEach(s => pills.push({ type: 'side-burners', value: s, label: `Side Burners: ${s}` }));
      currentFilters.rearRotisserie.forEach(r => pills.push({ type: 'rear-rotisserie', value: r, label: `Rear/Rotisserie: ${r}` }));
      currentFilters.colors.forEach(color => pills.push({ type: 'color', value: color, label: color }));
  
      if (currentFilters.priceMin !== null && currentFilters.priceMin > 0) {
        pills.push({ type: 'price-min', value: currentFilters.priceMin, label: `Min: $${currentFilters.priceMin}` });
      }
      if (currentFilters.priceMax !== null && currentFilters.priceMax > 0) {
        pills.push({ type: 'price-max', value: currentFilters.priceMax, label: `Max: $${currentFilters.priceMax}` });
      }
  
      // Metafield filter pills
      Object.entries(currentFilters.metafields).forEach(([metafieldKey, values]) => {
        if (values && values.size > 0) {
          const fc = window.filterConfig?.metafieldFilters?.find(f => f.filterKey === metafieldKey);
          const displayName = metafieldKey === 'custom.sale_offer_name'
            ? 'Offer'
            : (fc?.displayName || metafieldKey.split('.').pop());
          values.forEach(value => pills.push({ type: 'metafield', value: value, metafieldKey: metafieldKey, label: `${displayName}: ${value}` }));
        }
      });
  
      if (pills.length === 0) {
        els.activeFilters.style.display = 'none';
        return;
      }
  
      els.activeFilters.style.display = 'flex';
      els.activeFilters.innerHTML = pills.map(pill => {
        const removeArgs = pill.type === 'metafield'
          ? `'${pill.type}', '${escapeHtml(String(pill.value))}', '${escapeHtml(pill.metafieldKey)}'`
          : `'${pill.type}', '${escapeHtml(String(pill.value))}'`;
        return `
        <span style="display: inline-flex; align-items: center; gap: 6px; padding: 6px 10px; background: #f3f4f6; border: 1px solid #d1d5db; border-radius: 4px; font-size: 13px; color: #1a1a1a; font-weight: 400;">
          ${escapeHtml(pill.label)}
          <button onclick="removeFilter(${removeArgs})" style="background: none; border: none; padding: 0; margin-left: 2px; cursor: pointer; display: flex; align-items: center; color: #6b7280; transition: color 0.2s; line-height: 1;" title="Remove filter" onmouseover="this.style.color='#1a1a1a'" onmouseout="this.style.color='#6b7280'">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
              <path d="M3 3l6 6M9 3l-6 6"/>
            </svg>
          </button>
        </span>
      `}).join('');
  
      if (pills.length > 0) {
        els.activeFilters.innerHTML += `
          <button onclick="document.getElementById('clear-all-filters').click()" style="padding: 6px 12px; background: none; border: 1px solid #e5e7eb; color: #6b7280; font-size: 13px; font-weight: 400; cursor: pointer; border-radius: 4px; transition: all 0.2s;" onmouseover="this.style.borderColor='#1a1a1a'; this.style.color='#1a1a1a'" onmouseout="this.style.borderColor='#e5e7eb'; this.style.color='#6b7280'">
            Clear filters
          </button>
        `;
      }
    }
  
    window.removeFilter = function(type, value, metafieldKey) {
      if (type === 'brand') {
        currentFilters.brands.delete(value);
      } else if (type === 'type') {
        currentFilters.types.delete(value);
      } else if (type === 'color') {
        currentFilters.colors.delete(value);
      } else if (type === 'fuel_type') {
        currentFilters.fuelTypes.delete(value);
      } else if (type === 'taxonomy-configuration') {
        currentFilters.taxonomy.configuration.delete(value);
      } else if (type === 'series') {
        currentFilters.series.delete(value);
      } else if (type === 'main-burners') {
        currentFilters.mainBurners.delete(value);
      } else if (type === 'side-burners') {
        currentFilters.sideBurners.delete(value);
      } else if (type === 'rear-rotisserie') {
        currentFilters.rearRotisserie.delete(value);
      } else if (type === 'metafield' && metafieldKey) {
        if (currentFilters.metafields[metafieldKey]) {
          currentFilters.metafields[metafieldKey].delete(value);
        }
      } else if (type === 'price-min') {
        currentFilters.priceMin = null;
        els.priceMin.value = '';
        if (els.priceSliderMin) els.priceSliderMin.value = 0;
        updatePriceSliderRange();
      } else if (type === 'price-max') {
        currentFilters.priceMax = null;
        els.priceMax.value = '';
        if (els.priceSliderMax) els.priceSliderMax.value = 10000;
        updatePriceSliderRange();
      } else if (type === 'new-arrival') {
        currentFilters.newArrival = false;
        els.newArrivalToggle.checked = false;
      } else if (type === 'promotion') {
        currentFilters.promotion = false;
        els.promotionToggle.checked = false;
      } else if (type === 'clearance') {
        currentFilters.clearance = false;
        els.clearanceToggle.checked = false;
      } else if (type === 'canadian-brands') {
        currentFilters.canadianBrands = false;
        els.canadianBrandsToggle.checked = false;
      }
      updateClearButton();
      currentPage = 1;
      performSearch();
    };
  
    let priceTimeout;
    let priceSliderListenersAttached = false;
  
    function updatePriceSliderRange() {
      if (!els.priceSliderMin || !els.priceSliderMax || !els.priceSliderRange) return;
      const minVal = parseInt(els.priceSliderMin.value);
      const maxVal = parseInt(els.priceSliderMax.value);
      const rangeMax = 10000;
  
      const minPercent = (minVal / rangeMax) * 100;
      const maxPercent = (maxVal / rangeMax) * 100;
  
      els.priceSliderRange.style.left = minPercent + '%';
      els.priceSliderRange.style.right = (100 - maxPercent) + '%';
    }
  
    function attachPriceSliderListeners() {
      if (priceSliderListenersAttached) return;
      if (!els.priceMin || !els.priceMax || !els.priceSliderMin || !els.priceSliderMax) return;
  
      priceSliderListenersAttached = true;
  
      els.priceMin.addEventListener('input', () => {
        clearTimeout(priceTimeout);
        const val = parseFloat(els.priceMin.value);
        if (val >= 0) {
          els.priceSliderMin.value = val;
          updatePriceSliderRange();
        }
        priceTimeout = setTimeout(() => {
          currentFilters.priceMin = val > 0 ? val : null;
          updateClearButton();
          currentPage = 1;
          performSearch();
        }, 500);
      });
  
      els.priceMax.addEventListener('input', () => {
        clearTimeout(priceTimeout);
        const val = parseFloat(els.priceMax.value);
        if (val >= 0) {
          els.priceSliderMax.value = val;
          updatePriceSliderRange();
        }
        priceTimeout = setTimeout(() => {
          currentFilters.priceMax = val > 0 ? val : null;
          updateClearButton();
          currentPage = 1;
          performSearch();
        }, 500);
      });
  
      els.priceSliderMin.addEventListener('input', () => {
        let minVal = parseInt(els.priceSliderMin.value);
        let maxVal = parseInt(els.priceSliderMax.value);
  
        if (minVal > maxVal - 100) {
          minVal = maxVal - 100;
          els.priceSliderMin.value = minVal;
        }
  
        els.priceMin.value = minVal;
        updatePriceSliderRange();
  
        clearTimeout(priceTimeout);
        priceTimeout = setTimeout(() => {
          currentFilters.priceMin = minVal > 0 ? minVal : null;
          updateClearButton();
          currentPage = 1;
          performSearch();
        }, 500);
      });
  
      els.priceSliderMax.addEventListener('input', () => {
        let minVal = parseInt(els.priceSliderMin.value);
        let maxVal = parseInt(els.priceSliderMax.value);
  
        if (maxVal < minVal + 100) {
          maxVal = minVal + 100;
          els.priceSliderMax.value = maxVal;
        }
  
        els.priceMax.value = maxVal;
        updatePriceSliderRange();
  
        clearTimeout(priceTimeout);
        priceTimeout = setTimeout(() => {
          currentFilters.priceMax = maxVal < 10000 ? maxVal : null;
          updateClearButton();
          currentPage = 1;
          performSearch();
        }, 500);
      });
  
      // Initialize slider range from URL params
      if (currentFilters.priceMin) {
        els.priceMin.value = currentFilters.priceMin;
        els.priceSliderMin.value = currentFilters.priceMin;
      }
      if (currentFilters.priceMax) {
        els.priceMax.value = currentFilters.priceMax;
        els.priceSliderMax.value = currentFilters.priceMax;
      }
      updatePriceSliderRange();
    }
  
    els.sortSelect.addEventListener('change', (e) => {
      currentSort = e.target.value;
      userChangedSort = true; // User explicitly changed sort
      currentPage = 1;
      performSearch();
      // Sync mobile dropdown
      const mobileSort = document.getElementById('mobile-sort-select');
      if (mobileSort) mobileSort.value = currentSort;
    });
  
    // Mobile sort handler — called directly from mobile dropdown
    window.handleMobileSort = function(value) {
      DEBUG && console.log('🐛 MOBILE SORT: handleMobileSort called with value:', value);
      DEBUG && console.log('🐛 MOBILE SORT: currentSort before:', currentSort);
      currentSort = value;
      userChangedSort = true;
      currentPage = 1;
      DEBUG && console.log('🐛 MOBILE SORT: calling performSearch now');
      performSearch();
      if (els.sortSelect) els.sortSelect.value = value;
    };
  
    // Set initial sort value from URL
    els.sortSelect.value = currentSort;
  
    // Checkbox filter event listeners
    els.newArrivalToggle.addEventListener('change', handleFilterChange);
    els.promotionToggle.addEventListener('change', handleFilterChange);
    els.clearanceToggle.addEventListener('change', handleFilterChange);
    els.canadianBrandsToggle.addEventListener('change', handleFilterChange);
  
    // Set initial checkbox states from URL
    els.newArrivalToggle.checked = currentFilters.newArrival;
    els.promotionToggle.checked = currentFilters.promotion;
    els.clearanceToggle.checked = currentFilters.clearance;
    els.canadianBrandsToggle.checked = currentFilters.canadianBrands;
  
    els.clearAll.addEventListener('click', (e) => {
      e.preventDefault();
      currentFilters.brands.clear();
      currentFilters.types.clear();
      currentFilters.colors.clear();
      currentFilters.fuelTypes.clear();
      currentFilters.priceMin = null;
      currentFilters.priceMax = null;
      currentFilters.newArrival = false;
      currentFilters.promotion = false;
      currentFilters.clearance = false;
      currentFilters.canadianBrands = false;
      currentFilters.taxonomy.configuration.clear();
      currentFilters.series.clear();
      currentFilters.mainBurners.clear();
      currentFilters.sideBurners.clear();
      currentFilters.rearRotisserie.clear();
      // Clear all metafield filters
      Object.keys(currentFilters.metafields).forEach(key => {
        currentFilters.metafields[key].clear();
      });
      els.priceMin.value = '';
      els.priceMax.value = '';
      els.newArrivalToggle.checked = false;
      els.promotionToggle.checked = false;
      els.clearanceToggle.checked = false;
      els.canadianBrandsToggle.checked = false;
      if (els.priceSliderMin) els.priceSliderMin.value = 0;
      if (els.priceSliderMax) els.priceSliderMax.value = 10000;
      updatePriceSliderRange();
      updateClearButton();
      currentPage = 1;
      performSearch();
    });
  
    function setNoResultsMode(on) {
      if (!document.getElementById('no-results-mode-styles')) {
        var s = document.createElement('style');
        s.id = 'no-results-mode-styles';
        s.textContent =
          '#search-container.no-results-mode { grid-template-columns: 1fr !important; }' +
          '#search-container.no-results-mode #search-filters { display: none !important; }' +
          '#search-container.no-results-mode #search-results-grid { display: none !important; }' +
          '#search-container.no-results-mode #no-results { max-width: 1200px; margin-left: auto !important; margin-right: auto !important; }';
        document.head.appendChild(s);
      }
      var c = document.getElementById('search-container');
      if (!c) return;
      c.classList.toggle('no-results-mode', !!on);
    }

    function showLoading() {
      setNoResultsMode(false);
      els.loading.style.display = 'grid';
      els.noResults.style.display = 'none';
      els.resultsGrid.innerHTML = '';
      els.resultsHeader.style.display = 'none';
    }

    function hideLoading() {
      els.loading.style.display = 'none';
    }

    function showNoResults() {
      hideLoading();
      els.noResults.innerHTML = renderSmartNoResults(searchQuery || '');
      els.noResults.style.display = 'block';
      els.noResults.style.padding = '20px 16px';
      els.noResults.style.textAlign = 'left';
      els.noResults.style.minHeight = 'auto';
      els.noResults.style.height = 'auto';
      els.noResults.style.marginBottom = '0';
      setNoResultsMode(true);
      loadSmartSuggestions(searchQuery || '');
    }
  
    function showError(error) {
      hideLoading();
      // If Meilisearch is unreachable, show Shopify native search results as fallback
      const isServerDown = !error.httpStatus || error.httpStatus >= 500 || error.message === 'Failed to fetch' || (error.name === 'TypeError' && error.message.includes('fetch'));
      if (isServerDown && searchQuery) {
        // Use Shopify's search API to get results
        fetch('/search/suggest.json?q=' + encodeURIComponent(searchQuery) + '&resources[type]=product&resources[limit]=24')
          .then(function(r) { return r.json(); })
          .then(function(data) {
            const products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (products.length === 0) {
              els.noResults.innerHTML = renderSmartNoResults(searchQuery || '');
              els.noResults.style.display = 'block';
              setNoResultsMode(true);
              loadSmartSuggestions(searchQuery || '');
              return;
            }
            setNoResultsMode(false);
            document.getElementById('results-count').textContent = products.length + ' products';
            els.resultsGrid.innerHTML = products.map(function(p) {
              const price = parseFloat(p.price) || 0;
              return '<div class="product-card">' +
                '<a href="' + p.url + '" class="product-card-link">' +
                  '<div class="product-card-image-wrapper"><img src="' + escapeHtml(shopifyImageUrl(p.image || '', 300)) + '" alt="' + escapeHtml(p.title || '') + '" loading="lazy" class="product-card-image"></div>' +
                  '<div class="product-card-info">' +
                    '<h3 class="product-card-title">' + (p.title || '') + '</h3>' +
                    '<div class="product-card-price">$' + price.toLocaleString('en-CA', {minimumFractionDigits: 2}) + '</div>' +
                  '</div>' +
                '</a></div>';
            }).join('');
          })
          .catch(function() {
            els.noResults.innerHTML = '<h2 style="font-size: 24px; margin-bottom: 12px;">Search Unavailable</h2><p style="color: #999;">Please try again later or <a href="/collections/all">browse all products</a>.</p>';
            els.noResults.style.display = 'block';
            setNoResultsMode(true);
          });
      } else {
        els.noResults.innerHTML = `
          <h2 style="font-size: 24px; margin-bottom: 12px;">Search Error</h2>
          <p style="color: #999;">There was a problem. Please try again.</p>
        `;
        els.noResults.style.display = 'block';
        setNoResultsMode(true);
      }
    }
  
    // Smart "no results" rendering with helpful suggestions
    function renderSmartNoResults(query) {
      // Inject mobile-responsive styles once
      if (!document.getElementById('smart-noresults-styles')) {
        var style = document.createElement('style');
        style.id = 'smart-noresults-styles';
        style.textContent = '@media (max-width: 600px) {' +
          '.smart-nr-heading { font-size: 22px !important; }' +
          '.smart-nr-pill { padding: 12px 18px !important; font-size: 14px !important; min-height: 44px !important; }' +
          '.smart-nr-grid { grid-template-columns: repeat(2, 1fr) !important; gap: 10px !important; }' +
          '.smart-nr-card { padding: 10px !important; }' +
          '.smart-nr-card-title { font-size: 13px !important; }' +
          '.smart-nr-card-price { font-size: 14px !important; }' +
          '.smart-nr-cta { padding: 16px 24px !important; width: 100%; max-width: 320px; }' +
        '}';
        document.head.appendChild(style);
      }
      return '<div style="padding:8px 0;">' +
        '<div style="text-align:center;padding:0 16px 32px;">' +
          '<div style="display:inline-flex;align-items:center;justify-content:center;width:56px;height:56px;background:#f3f4f6;border-radius:50%;margin-bottom:18px;">' +
            '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" stroke-width="2"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>' +
          '</div>' +
          '<h2 class="smart-nr-heading" style="font-size:28px;font-weight:700;margin:0 0 8px;color:#111;">No results for "' + escapeHtml(query) + '"</h2>' +
          '<p style="color:#6b7280;font-size:16px;margin:0;">We couldn\'t find any matching products.</p>' +
        '</div>' +
        '<div id="smart-popular" style="margin-bottom:28px;"></div>' +
        '<div id="smart-bestsellers"></div>' +
        '<div style="text-align:center;padding:24px 0 0;">' +
          '<a class="smart-nr-cta" href="/collections/all" style="display:inline-block;padding:14px 32px;background:#1a1a1a;color:#fff;border-radius:6px;text-decoration:none;font-size:15px;font-weight:600;">Browse all products</a>' +
        '</div>' +
        '</div>';
    }
  
    function loadSmartSuggestions(query) {
      // 1. Popular searches as quick chips
      fetch('https://search.bbqing.com/api/search-suggestions').then(function(r) { return r.json(); }).then(function(suggestions) {
        var picks = (suggestions || []).slice(0, 6);
        if (picks.length === 0) return;
        var html = '<div style="border-top:1px solid #e5e7eb;padding-top:28px;">' +
          '<div style="font-size:16px;font-weight:600;color:#111;margin-bottom:16px;text-align:center;">Try one of these popular searches</div>' +
          '<div style="display:flex;flex-wrap:wrap;gap:10px;justify-content:center;">' +
          picks.map(function(s) {
            return '<a class="smart-nr-pill" href="/search?q=' + encodeURIComponent(s) + '" style="display:inline-flex;align-items:center;padding:10px 20px;background:#fff;border:1.5px solid #d1d5db;border-radius:24px;text-decoration:none;color:#1a1a1a;font-size:14px;font-weight:500;transition:all 0.15s;" onmouseover="this.style.background=\'#1a1a1a\';this.style.color=\'#fff\';this.style.borderColor=\'#1a1a1a\';" onmouseout="this.style.background=\'#fff\';this.style.color=\'#1a1a1a\';this.style.borderColor=\'#d1d5db\';">' + escapeHtml(s) + '</a>';
          }).join('') +
          '</div></div>';
        var el = document.getElementById('smart-popular');
        if (el) el.innerHTML = html;
      }).catch(function(){});
  
      // 2. Featured collections — fetch image live from Shopify by handle
      var NR_COLLECTIONS = [
        { handle: 'pellet-grills',                    name: 'Pellet Grills' },
        { handle: 'griddles-cooktop-grills',          name: 'Griddles & Cooktop Grills' },
        { handle: 'pizza-ovens',                      name: 'Pizza Ovens' },
        { handle: 'bbq-accessories',                  name: 'BBQ Accessories' },
        { handle: 'outdoor-kitchen-pre-built-bundles', name: 'Outdoor Kitchen Pre-Builds' },
        { handle: 'natural-gas-propane-bbqs',         name: 'Gas Grills' }
      ];
      Promise.all(NR_COLLECTIONS.map(function(c) {
        return fetch('/collections/' + c.handle + '.json').then(function(r) { return r.json(); }).then(function(d) {
          var col = d && d.collection ? d.collection : {};
          return {
            name: c.name,
            url: '/collections/' + c.handle,
            image: (col.image && (col.image.src || col.image)) || ''
          };
        }).catch(function() { return { name: c.name, url: '/collections/' + c.handle, image: '' }; });
      })).then(function(items) {
        if (items.length === 0) return;
        var html = '<div style="border-top:1px solid #e5e7eb;padding-top:28px;">' +
          '<div style="font-size:16px;font-weight:600;color:#111;margin-bottom:18px;text-align:center;">Or browse a category</div>' +
          '<div class="smart-nr-grid" style="display:grid;grid-template-columns:repeat(6,1fr);gap:12px;">' +
          items.map(function(c) {
            var img = c.image && typeof shopifyImageUrl === 'function' ? shopifyImageUrl(c.image, 400) : c.image;
            return '<a href="' + escapeHtml(c.url) + '" style="text-decoration:none;color:inherit;">' +
              '<div class="smart-nr-card" style="background:#fff;border:1px solid #e5e7eb;border-radius:8px;padding:14px;transition:border-color 0.15s;" onmouseover="this.style.borderColor=\'#1a1a1a\';" onmouseout="this.style.borderColor=\'#e5e7eb\';">' +
              (img ? '<div style="aspect-ratio:1;background:#f9fafb;border-radius:4px;margin-bottom:12px;display:flex;align-items:center;justify-content:center;overflow:hidden;"><img src="' + escapeHtml(img) + '" alt="" style="width:100%;height:100%;object-fit:cover;"></div>' : '<div style="aspect-ratio:1;background:#f3f4f6;border-radius:4px;margin-bottom:12px;"></div>') +
              '<div class="smart-nr-card-title" style="font-size:14px;color:#1a1a1a;line-height:1.4;font-weight:600;text-align:center;">' + escapeHtml(c.name) + '</div>' +
              '</div></a>';
          }).join('') +
          '</div></div>';
        var el = document.getElementById('smart-bestsellers');
        if (el) el.innerHTML = html;
      }).catch(function(){});
    }
  
    // Product Comparison Functions
    const variantCache = new Map();
    let modalCompareState = null;

    function extractHandleFromUrl(url) {
      if (!url) return '';
      const match = String(url).match(/\/products\/([^?#\/]+)/);
      return match ? match[1] : '';
    }

    function buildVariantLabel(variant) {
      const parts = [];
      for (let i = 1; i <= 3; i++) {
        const name = variant['option' + i + '_name'];
        const val = variant['option' + i + '_value'];
        if (val && val !== 'Default Title' && !(name === 'Title' && val === 'Default Title')) {
          parts.push(val);
        }
      }
      if (parts.length) return parts.join(' / ');
      if (variant.variant_title && variant.variant_title !== 'Default Title') {
        return variant.variant_title;
      }
      return 'Default';
    }

    async function loadVariantsForHandle(handle) {
      if (!handle) return [];
      if (variantCache.has(handle)) return variantCache.get(handle);
      try {
        // Search by handle text, then filter client-side for exact handle match.
        // (Direct filter on `handle` requires it to be a Meilisearch filterable attribute.)
        const searchTerm = handle.replace(/-/g, ' ');
        const response = await index.search(searchTerm, { limit: 100 });
        const hits = (response.hits || []).filter(h => h.handle === handle);
        variantCache.set(handle, hits);
        return hits;
      } catch (e) {
        return [];
      }
    }

    window.toggleCompare = function(productId, checked) {
      if (checked) {
        if (compareProducts.size >= MAX_COMPARE) {
          alert(`You can only compare up to ${MAX_COMPARE} products at a time.`);
          displayResults(allProducts);
          return;
        }
        compareProducts.add(productId);
      } else {
        compareProducts.delete(productId);
      }
      localStorage.setItem('compareProducts', JSON.stringify([...compareProducts]));
      updateCompareBar();
      displayResults(allProducts);
    };
  
    function updateCompareBar() {
      let compareBar = document.getElementById('compare-bar');
  
      // Prune compare IDs that aren't in current results (e.g. from a different page)
      if (allProducts.length > 0) {
        const availableIds = new Set(allProducts.map(p => p.id));
        const staleIds = [...compareProducts].filter(id => !availableIds.has(id));
        staleIds.forEach(id => compareProducts.delete(id));
        if (staleIds.length > 0) {
          localStorage.setItem('compareProducts', JSON.stringify([...compareProducts]));
        }
      }
  
      if (compareProducts.size === 0) {
        if (compareBar) compareBar.remove();
        return;
      }
  
      if (!compareBar) {
        compareBar = document.createElement('div');
        compareBar.id = 'compare-bar';
        document.body.appendChild(compareBar);
      }
  
      const selectedProducts = allProducts.filter(p => compareProducts.has(p.id));
  
      compareBar.innerHTML = `
        <div style="position: fixed; bottom: 0; left: 0; right: 0; background: white; border-top: 2px solid #1a1a1a; box-shadow: 0 -4px 12px rgba(0,0,0,0.15); z-index: 1000; padding: 16px 20px;">
          <div style="max-width: 1600px; margin: 0 auto; display: flex; align-items: center; justify-content: space-between; gap: 20px; flex-wrap: wrap;">
            <div style="display: flex; align-items: center; gap: 16px; flex: 1; overflow-x: auto;">
              <div style="font-size: 14px; font-weight: 600; color: #1a1a1a; white-space: nowrap;">
                Compare (${compareProducts.size}/${MAX_COMPARE})
              </div>
              <div style="display: flex; gap: 10px; overflow-x: auto; flex: 1;">
                ${selectedProducts.map(p => `
                  <div style="display: flex; align-items: center; gap: 8px; padding: 8px 12px; background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 6px; white-space: nowrap;">
                    <img src="${escapeHtml(shopifyImageUrl(p.image_url, 80))}" alt="" style="width: 40px; height: 40px; object-fit: contain; border-radius: 4px; background: white;">
                    <span style="font-size: 13px; color: #1a1a1a; max-width: 120px; overflow: hidden; text-overflow: ellipsis; font-weight: 500;">${escapeHtml(p.full_title)}</span>
                    <button onclick="toggleCompare('${p.id}', false)" style="background: none; border: none; padding: 4px; cursor: pointer; color: #9ca3af; display: flex; align-items: center; transition: color 0.2s;" title="Remove" onmouseover="this.style.color='#1a1a1a'" onmouseout="this.style.color='#9ca3af'">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M4 4l8 8M12 4l-8 8"/>
                      </svg>
                    </button>
                  </div>
                `).join('')}
              </div>
            </div>
            <div style="display: flex; gap: 12px; align-items: center;">
              <button onclick="clearCompare()" style="padding: 10px 18px; background: white; border: 1px solid #d1d5db; color: #6b7280; font-size: 14px; font-weight: 500; cursor: pointer; border-radius: 6px; white-space: nowrap; transition: all 0.2s;"
                      onmouseover="this.style.background='#f9fafb'; this.style.borderColor='#9ca3af';"
                      onmouseout="this.style.background='white'; this.style.borderColor='#d1d5db';">
                Clear All
              </button>
              <button onclick="showCompareModal()" style="padding: 10px 24px; background: #1a1a1a; color: white; border: none; font-size: 14px; font-weight: 600; cursor: pointer; border-radius: 6px; white-space: nowrap; transition: all 0.2s;"
                      onmouseover="this.style.opacity='0.85';"
                      onmouseout="this.style.opacity='1';">
                Compare (${compareProducts.size})
              </button>
            </div>
          </div>
        </div>
      `;
    }
  
    window.clearCompare = function() {
      compareProducts.clear();
      localStorage.setItem('compareProducts', JSON.stringify([]));
      updateCompareBar();
      displayResults(allProducts);
    };
  
  
    window.showCompareModal = async function() {
      const initialProducts = allProducts.filter(p => compareProducts.has(p.id));

      if (initialProducts.length < 2) {
        alert('Please select at least 2 products to compare');
        return;
      }

      let loadingModal = document.getElementById('compare-modal');
      if (!loadingModal) {
        loadingModal = document.createElement('div');
        loadingModal.id = 'compare-modal';
        document.body.appendChild(loadingModal);
        document.body.style.overflow = 'clip';
      }
      loadingModal.innerHTML = `
        <div style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.6); z-index: 2000; display: flex; align-items: center; justify-content: center;" onclick="closeCompareModal()">
          <div style="background: white; padding: 32px 48px; border-radius: 12px; font-size: 14px; color: #6b7280;">Loading comparison…</div>
        </div>
      `;

      const variantsArr = await Promise.all(
        initialProducts.map(p => loadVariantsForHandle(extractHandleFromUrl(p.url)))
      );

      modalCompareState = { products: {}, current: {} };
      initialProducts.forEach((p, idx) => {
        let variants = variantsArr[idx];
        if (!variants || !variants.length) variants = [p];
        if (!variants.find(v => v.id === p.id)) variants = [p].concat(variants);
        modalCompareState.products[p.id] = variants;
        modalCompareState.current[p.id] = p.id;
      });

      renderCompareModal();
    };

    window.changeCompareVariant = function(origId, newVariantId) {
      if (!modalCompareState || !modalCompareState.products[origId]) return;
      modalCompareState.current[origId] = newVariantId;
      renderCompareModal();
    };

    function renderCompareModal() {
      if (!modalCompareState) return;
      const origIds = Object.keys(modalCompareState.current);
      const currentVariants = origIds.map(origId => {
        const variants = modalCompareState.products[origId];
        const currentId = modalCompareState.current[origId];
        return variants.find(v => v.id === currentId) || variants[0];
      });

      let modal = document.getElementById('compare-modal');
      if (!modal) {
        modal = document.createElement('div');
        modal.id = 'compare-modal';
        document.body.appendChild(modal);
        document.body.style.overflow = 'clip';
      }

      modal.innerHTML = `
        <div style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.6); z-index: 2000; display: flex; align-items: center; justify-content: center; padding: 20px;" onclick="closeCompareModal()">
          <div role="dialog" aria-modal="true" aria-label="Compare Products" style="background: white; border-radius: 12px; max-width: 1400px; width: 100%; max-height: 90vh; overflow: auto; box-shadow: 0 20px 60px rgba(0,0,0,0.3);" onclick="event.stopPropagation()">
            <div style="position: sticky; top: 0; background: white; border-bottom: 1px solid #e5e7eb; padding: 24px; display: flex; justify-content: space-between; align-items: center; z-index: 10; border-radius: 12px 12px 0 0;">
              <h2 style="font-size: 20px; font-weight: 600; margin: 0; color: #1a1a1a;">Product Comparison</h2>
              <button onclick="closeCompareModal()" style="background: none; border: none; padding: 8px; cursor: pointer; color: #9ca3af; display: flex; align-items: center; transition: color 0.2s;" title="Close" onmouseover="this.style.color='#1a1a1a'" onmouseout="this.style.color='#9ca3af'">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M6 6l12 12M18 6l-12 12"/>
                </svg>
              </button>
            </div>
            <div style="padding: 32px; overflow-x: auto;">
              <table style="width: 100%; border-collapse: separate; border-spacing: 0; min-width: 600px;">
                <thead>
                  <tr>
                    <th style="padding: 16px; text-align: left; font-size: 13px; font-weight: 600; color: #9ca3af; background: #ffffff; border-bottom: 2px solid #e5e7eb; position: sticky; left: 0; z-index: 5; text-transform: uppercase; letter-spacing: 0.5px;"></th>
                    ${origIds.map((origId, idx) => {
                      const variant = currentVariants[idx];
                      const allVariants = modalCompareState.products[origId];
                      const variantLabel = buildVariantLabel(variant);
                      return `
                        <th style="padding: 16px; text-align: center; background: #ffffff; border-bottom: 2px solid #e5e7eb; min-width: 220px; vertical-align: top;">
                          <img src="${escapeHtml(shopifyImageUrl(variant.image_url || '', 200))}" alt="" style="width: 100px; height: 100px; object-fit: contain; margin: 0 auto 12px; border-radius: 8px; background: white; padding: 8px; border: 1px solid #e5e7eb;">
                          <div style="color: #1a1a1a; line-height: 1.4; font-weight: 600; font-size: 14px; margin-bottom: 10px;">${escapeHtml(variant.title || '')}</div>
                          ${allVariants.length > 1
                            ? `<select onchange="changeCompareVariant('${origId}', this.value)" aria-label="Select variant" style="width: 100%; max-width: 200px; padding: 6px 10px; border: 1px solid #d1d5db; border-radius: 6px; font-size: 12px; color: #1a1a1a; background: white; cursor: pointer; margin-bottom: 10px;">
                                ${allVariants.map(v => `<option value="${v.id}" ${v.id === variant.id ? 'selected' : ''}>${escapeHtml(buildVariantLabel(v))}</option>`).join('')}
                              </select>`
                            : `<div style="font-size: 12px; color: #6b7280; margin-bottom: 10px;">${escapeHtml(variantLabel)}</div>`}
                          <div style="font-size: 18px; font-weight: 700; color: #1a1a1a;">$${formatPrice(variant.price)}</div>
                        </th>
                      `;
                    }).join('')}
                  </tr>
                </thead>
                <tbody>
                  ${buildComparisonRows(currentVariants)}
                </tbody>
              </table>
            </div>
            <div style="padding: 24px; background: #fafafa; border-top: 1px solid #e5e7eb; display: flex; justify-content: space-between; align-items: center; border-radius: 0 0 12px 12px;">
              <button onclick="clearCompare(); closeCompareModal();" style="padding: 10px 18px; background: white; border: 1px solid #d1d5db; color: #6b7280; font-size: 14px; font-weight: 500; cursor: pointer; border-radius: 6px; transition: all 0.2s;"
                      onmouseover="this.style.background='#f9fafb'; this.style.borderColor='#9ca3af';"
                      onmouseout="this.style.background='white'; this.style.borderColor='#d1d5db';">
                Clear All & Close
              </button>
              <button onclick="closeCompareModal()" style="padding: 10px 24px; background: #1a1a1a; color: white; border: none; font-size: 14px; font-weight: 600; cursor: pointer; border-radius: 6px; transition: all 0.2s;"
                      onmouseover="this.style.opacity='0.85';"
                      onmouseout="this.style.opacity='1';">
                Close
              </button>
            </div>
          </div>
        </div>
      `;
    }

    function buildComparisonRows(products) {
      const getValue = (product, key) => {
        if (product == null) return undefined;
        // Meilisearch flattens metaobjects with dot-in-key-name (e.g. "pizza_oven_specs.fuel_type" is one key, not nested)
        if (Object.prototype.hasOwnProperty.call(product, key)) return product[key];
        // Fall back to nested path lookup
        return key.split('.').reduce((obj, k) => (obj == null ? undefined : obj[k]), product);
      };
      const isPresent = (v) => v !== undefined && v !== null && v !== '';
      const formatVal = (v, p, key) => {
        if (key === 'sku' && !isPresent(v) && p) return p.variant_sku || 'N/A';
        if (v === true || v === 'true') return 'Yes';
        if (v === false || v === 'false') return 'No';
        if (Array.isArray(v)) return v.join(', ') || 'N/A';
        if (!isPresent(v)) return 'N/A';
        return String(v);
      };

      const sections = [
        {
          label: null,
          rows: [
            { label: 'Brand', key: 'vendor' },
            { label: 'SKU', key: 'sku' },
            { label: 'Series', key: 'general_specs.series' },
            { label: 'Fuel Type', key: 'fuel_type' },
          ]
        },
        {
          label: 'BBQ Specifications',
          rows: [
            { label: 'Cooking Capacity', key: 'bbq_specs.cooking_capacity' },
            { label: 'Main Cooking Area (sq in)', key: 'bbq_specs.main_cooking_area_sq_in' },
            { label: 'Total BTU', key: 'bbq_specs.total_btu' },
            { label: 'Main Burner BTU', key: 'bbq_specs.main_burner_btu' },
            { label: '# of Main Burners', key: 'bbq_specs.main_burner_count' },
            { label: 'Side Burner', key: 'bbq_specs.side_burner_included' },
            { label: 'Rear Burner', key: 'bbq_specs.rear_burner_included' },
            { label: 'Rotisserie Kit', key: 'bbq_specs.rotisserie_included' },
            { label: 'Cooking Grate Type', key: 'bbq_specs.cooking_grate_type' },
            { label: 'Cooking Grate Size', key: 'bbq_specs.cooking_grate_size' },
            { label: 'Temperature Range', key: 'bbq_specs.temperature_range' },
            { label: 'WiFi Enabled', key: 'bbq_specs.wi_fi_enabled' },
            { label: 'Bluetooth Enabled', key: 'bbq_specs.bluetooth_enabled' },
          ]
        },
        {
          label: 'Pizza Oven Specifications',
          rows: [
            { label: 'Cooking Floor Area', key: 'pizza_oven_specs.cooking_floor_area' },
            { label: 'Temperature Range', key: 'pizza_oven_specs.temperature_range' },
            { label: 'Max Pizza Size', key: 'pizza_oven_specs.max_pizza_size' },
            { label: 'Heat-Up Time', key: 'pizza_oven_specs.heat_up_time' },
            { label: 'Pizzas Per Hour', key: 'pizza_oven_specs.pizzas_per_hour' },
            { label: 'Baking Stone Size', key: 'pizza_oven_specs.baking_stone_size' },
            { label: 'Baking Stone Thickness', key: 'pizza_oven_specs.baking_stone_thickness' },
            { label: 'Stone Material', key: 'pizza_oven_specs.stone_material' },
            { label: 'Max Clearance Above Stone', key: 'pizza_oven_specs.max_clearance_above_stone' },
            { label: 'Built-In Thermometer', key: 'pizza_oven_specs.built_in_thermometer' },
            { label: 'Thermometer Type', key: 'pizza_oven_specs.thermometer_type' },
            { label: 'Door Included', key: 'pizza_oven_specs.door_included' },
            { label: 'Door Type', key: 'pizza_oven_specs.door_type' },
            { label: 'Wi-Fi / Bluetooth', key: 'pizza_oven_specs.wi_fi_bluetooth' },
            { label: 'Probe Included', key: 'pizza_oven_specs.probe_included' },
            { label: 'Wheels / Locking Casters', key: 'pizza_oven_specs.wheels_locking_casters' },
            { label: 'Assembly Required', key: 'pizza_oven_specs.assembly_required' },
            { label: 'Indoor / Outdoor Rated', key: 'pizza_oven_specs.indoor_outdoor_rated' },
          ]
        },
        {
          label: 'Pellet Grill & Smoker Specifications',
          rows: [
            { label: 'Cooking Capacity', key: 'pellet_specs.cooking_capacity' },
            { label: 'Total Cooking Area (sq in)', key: 'pellet_specs.total_cooking_area_sq_in' },
            { label: 'Pellet Hopper Capacity (lbs)', key: 'pellet_specs.pellet_hopper_capacity_lbs' },
            { label: 'Hopper Clean-Out', key: 'pellet_specs.hopper_clean_out' },
            { label: 'Pellet Sensor / Low Pellet Alert', key: 'pellet_specs.pellet_sensor_low_pellet_alert' },
            { label: 'Number of Cooking Racks', key: 'pellet_specs.number_of_cooking_racks' },
            { label: 'Cooking Grate Type', key: 'pellet_specs.cooking_grate_type' },
            { label: 'Temperature Range', key: 'pellet_specs.temperature_range' },
            { label: 'PID Controller', key: 'pellet_specs.pid_controller' },
            { label: 'Smoke Mode / Enhanced Smoke', key: 'pellet_specs.smoke_mode_enhanced_smoke_setting' },
            { label: 'Keep Warm Mode', key: 'pellet_specs.keep_warm_mode' },
            { label: 'Wi-Fi Enabled', key: 'pellet_specs.wi_fi_enabled' },
            { label: 'Bluetooth Enabled', key: 'pellet_specs.bluetooth_enabled' },
            { label: 'App Control', key: 'pellet_specs.app_control' },
            { label: 'Meat Probe(s) Included', key: 'pellet_specs.meat_probe_s_included' },
            { label: 'Rotisserie Compatible', key: 'pellet_specs.rotisserie_compatible' },
            { label: 'Side Burner', key: 'pellet_specs.side_burner_included' },
            { label: 'Cabinet / Storage', key: 'pellet_specs.cabinet_storage_included' },
            { label: 'Wheels / Locking Casters', key: 'pellet_specs.wheels_locking_casters' },
            { label: 'Assembly Required', key: 'pellet_specs.assembly_required' },
          ]
        },
        {
          label: 'Charcoal Grill Specifications',
          rows: [
            { label: 'Cooking Capacity', key: 'charcoal_specs.cooking_capacity' },
            { label: 'Grill Style', key: 'charcoal_specs.grill_style' },
            { label: 'Main Cooking Area (sq in)', key: 'charcoal_specs.main_cooking_area_sq_in' },
            { label: 'Total Cooking Area (sq in)', key: 'charcoal_specs.total_cooking_area_sq_in' },
            { label: 'Warming Rack Area (sq in)', key: 'charcoal_specs.warming_rack_area_sq_in' },
            { label: 'Cooking Grate Type', key: 'charcoal_specs.cooking_grate_type' },
            { label: 'Cooking Grate Size', key: 'charcoal_specs.cooking_grate_size' },
            { label: 'Cooking Grate Thickness', key: 'charcoal_specs.cooking_grate_thickness' },
            { label: 'GBS / Cooking System Compatible', key: 'charcoal_specs.gbs_cooking_system_compatible' },
            { label: 'Charcoal Capacity', key: 'charcoal_specs.charcoal_capacity' },
            { label: 'Firebox Material', key: 'charcoal_specs.firebox_material' },
            { label: 'Max Temperature', key: 'charcoal_specs.max_temperature' },
            { label: 'Temperature Range', key: 'charcoal_specs.temperature_range' },
            { label: 'Top Vent Type', key: 'charcoal_specs.top_vent_type' },
            { label: 'Bottom Vent Type', key: 'charcoal_specs.bottom_vent_type' },
            { label: 'Ash Removal System', key: 'charcoal_specs.ash_removal_system' },
            { label: 'Heat Deflector / Indirect Cooking Accessory', key: 'charcoal_specs.heat_deflector_indirect_cooking_accessory_included' },
            { label: 'Charcoal Rails / Baskets', key: 'charcoal_specs.charcoal_rails_baskets_included' },
            { label: 'Water Pan / Drip Pan', key: 'charcoal_specs.water_pan_drip_pan_included' },
            { label: 'Built-In Thermometer', key: 'charcoal_specs.built_in_thermometer' },
            { label: 'Probe Port Included', key: 'charcoal_specs.probe_port_included' },
            { label: 'Meat Probe(s) Included', key: 'charcoal_specs.meat_probe_s_included' },
            { label: 'Wi-Fi Enabled', key: 'charcoal_specs.wi_fi_enabled' },
            { label: 'Bluetooth Enabled', key: 'charcoal_specs.bluetooth_enabled' },
            { label: 'Rotisserie Compatible', key: 'charcoal_specs.rotisserie_compatible' },
            { label: 'Rotisserie Included', key: 'charcoal_specs.rotisserie_included' },
            { label: 'Side Shelves', key: 'charcoal_specs.side_shelves_included' },
            { label: 'Tool Hooks', key: 'charcoal_specs.tool_hooks' },
            { label: 'Wheels / Locking Casters', key: 'charcoal_specs.wheels_locking_casters' },
            { label: 'Cabinet / Storage', key: 'charcoal_specs.cabinet_storage_included' },
          ]
        },
        {
          label: 'Griddle Specifications',
          rows: [
            { label: 'Cooking Capacity', key: 'griddle_specs.cooking_capacity' },
            { label: 'Total Cooking Area (sq in)', key: 'griddle_specs.total_cooking_area_sq_in' },
            { label: 'Cooktop Material', key: 'griddle_specs.cooktop_material' },
            { label: 'Cooktop Thickness', key: 'griddle_specs.cooktop_thickness' },
            { label: 'Pre-Seasoned', key: 'griddle_specs.pre_seasoned' },
            { label: 'Number of Burner Zones', key: 'griddle_specs.number_of_burner_zones' },
            { label: 'Total BTU', key: 'griddle_specs.total_btu' },
            { label: 'Temperature Range', key: 'griddle_specs.temperature_range' },
            { label: 'Ignition Type', key: 'griddle_specs.ignition_type' },
            { label: 'Hood / Lid Included', key: 'griddle_specs.hood_lid_included' },
            { label: 'Hood Type', key: 'griddle_specs.hood_type' },
            { label: 'Side Burner', key: 'griddle_specs.side_burner_included' },
            { label: 'Grease Management Type', key: 'griddle_specs.grease_management_type' },
            { label: 'App Control', key: 'griddle_specs.app_control' },
            { label: 'Wi-Fi Enabled', key: 'griddle_specs.wi_fi_enabled' },
            { label: 'Cabinet Storage', key: 'griddle_specs.cabinet_storage_included' },
            { label: 'Wheels / Locking Casters', key: 'griddle_specs.wheels_locking_casters' },
            { label: 'Assembly Required', key: 'griddle_specs.assembly_required' },
          ]
        },
        {
          label: 'Build & Dimensions',
          rows: [
            { label: 'Product Width', key: 'general_specs.product_width' },
            { label: 'Product Width (Shelves Down)', key: 'general_specs.product_width_shelves_down' },
            { label: 'Product Height', key: 'general_specs.product_height' },
            { label: 'Product Height (Lid Open)', key: 'general_specs.product_height_lid_open' },
            { label: 'Product Weight', key: 'general_specs.product_net_weight' },
            { label: 'Wheels / Locking Casters', key: 'general_specs.wheels_locking_casters' },
            { label: 'Assembly Required', key: 'general_specs.assembly_required' },
            { label: 'Indoor / Outdoor Rated', key: 'general_specs.indoor_outdoor_rated' },
          ]
        },
      ];

      let html = '';
      let rowIdx = 0;
      const colCount = products.length + 1;

      for (const section of sections) {
        const visibleRows = section.rows.filter(row =>
          products.some(p => isPresent(getValue(p, row.key)))
        );
        if (visibleRows.length === 0) continue;

        if (section.label) {
          html += `<tr><td colspan="${colCount}" style="padding: 14px 16px; background: #1a1a1a; color: white; font-size: 12px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.6px; position: sticky; left: 0;">${section.label}</td></tr>`;
        }

        for (const row of visibleRows) {
          const bg = rowIdx % 2 === 0 ? '#fafafa' : 'white';
          html += `
            <tr>
              <td style="padding: 20px 16px; font-size: 13px; font-weight: 600; color: #6b7280; background: ${bg}; border-bottom: 1px solid #f3f4f6; position: sticky; left: 0; z-index: 5; text-transform: uppercase; letter-spacing: 0.5px;">${row.label}</td>
              ${products.map(p => {
                const val = getValue(p, row.key);
                return `<td style="padding: 20px 16px; text-align: center; font-size: 14px; color: #1a1a1a; background: ${bg}; border-bottom: 1px solid #f3f4f6; font-weight: 500;">${escapeHtml(formatVal(val, p, row.key))}</td>`;
              }).join('')}
            </tr>
          `;
          rowIdx++;
        }
      }

      return html;
    }
  
    window.closeCompareModal = function() {
      const modal = document.getElementById('compare-modal');
      if (modal) modal.remove();
      document.body.style.overflow = '';
    };
  
    // Initialize compare bar on load
    if (compareProducts.size > 0) {
      updateCompareBar();
    }
  
    // Toggle filter section visibility
    window.toggleFilterSection = function(section) {
      const optionsDiv = document.getElementById(`${section}-filter-options`);
      const arrow = document.getElementById(`${section}-arrow`);
  
      if (optionsDiv.style.display === 'none') {
        optionsDiv.style.display = 'block';
        arrow.style.transform = 'rotate(180deg)';
      } else {
        optionsDiv.style.display = 'none';
        arrow.style.transform = 'rotate(0deg)';
      }
      optionsDiv.setAttribute('aria-expanded', optionsDiv.style.display !== 'none');
    };
  
    // Quick view modal
    window.showQuickView = function(productId) {
      const product = allProducts.find(p => p.id === productId);
      if (!product) return;
  
      DEBUG && console.log('Quick View product data:', product);
      DEBUG && console.log('variant_id:', product.variant_id);
  
      // Price display
      const hasDiscount = product.compare_at_price && product.compare_at_price > product.price;
      const priceHtml = hasDiscount
        ? `<div style="display: flex; align-items: baseline; gap: 12px; margin-bottom: 20px;">
             <span style="font-size: 32px; font-weight: 700; color: #dc2626;">$${formatPrice(product.price)}</span>
             <span style="font-size: 20px; color: #9ca3af; text-decoration: line-through;">$${formatPrice(product.compare_at_price)}</span>
           </div>`
        : `<div style="font-size: 32px; font-weight: 700; color: #1a1a1a; margin-bottom: 20px;">$${formatPrice(product.price)}</div>`;
  
      // Product metadata (plain text, no background)
      const metadataItems = [];
      if (product.sku) metadataItems.push(`<div style="font-size: 13px; color: #6b7280; margin-bottom: 12px;"><strong style="color: #4b5563;">SKU:</strong> ${escapeHtml(product.sku)}</div>`);
      if (product['general_specs.series']) metadataItems.push(`<div style="font-size: 13px; color: #6b7280; margin-bottom: 12px;"><strong style="color: #4b5563;">Series:</strong> ${escapeHtml(product['general_specs.series'])}</div>`);
  
      // Show variant info using actual option names from the product data
      const optionParts = [];
      for (let i = 1; i <= 3; i++) {
        const optName = product[`option${i}_name`];
        const optVal = product[`option${i}_value`];
        if (optName && optVal) {
          optionParts.push(`<strong style="color: #4b5563;">${escapeHtml(optName)}:</strong> ${escapeHtml(optVal)}`);
        }
      }
      if (optionParts.length > 0) {
        metadataItems.push(`<div style="font-size: 13px; color: #6b7280; margin-bottom: 12px;">${optionParts.join(' <span style="color: #d1d5db; margin: 0 8px;">|</span> ')}</div>`);
      }
  
      const metadataHtml = metadataItems.join('');
  
      const modal = document.getElementById('quick-view-modal');
      modal.innerHTML = `
        <div class="quick-view-overlay" style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.75); z-index: 3000; display: flex; align-items: center; justify-content: center; padding: 20px; animation: fadeIn 0.2s ease-out;" onclick="closeQuickView()">
          <div class="quick-view-content" role="dialog" aria-modal="true" aria-label="Quick View" style="background: white; border-radius: 8px; max-width: 1000px; width: 100%; max-height: 90vh; overflow: hidden; box-shadow: 0 25px 50px -12px rgba(0,0,0,0.25); animation: slideUp 0.3s ease-out;" onclick="event.stopPropagation()">
            <div style="position: sticky; top: 0; background: white; border-bottom: 1px solid #f3f4f6; padding: 24px 32px; display: flex; justify-content: space-between; align-items: center; z-index: 10;">
              <h2 style="font-size: 20px; font-weight: 700; margin: 0; color: #111827;">Quick View</h2>
              <button onclick="closeQuickView()" style="background: #f3f4f6; border: none; padding: 10px; cursor: pointer; color: #6b7280; border-radius: 8px; transition: all 0.2s; display: flex; align-items: center; justify-content: center;" onmouseover="this.style.background='#e5e7eb'; this.style.color='#111827';" onmouseout="this.style.background='#f3f4f6'; this.style.color='#6b7280';" title="Close">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
                  <path d="M6 6l12 12M18 6l-12 12"/>
                </svg>
              </button>
            </div>
            <div style="padding: 40px; display: grid; grid-template-columns: 1fr 1fr; gap: 48px; overflow-y: auto; max-height: calc(90vh - 80px);">
              <div>
                <div style="background: #f9fafb; border-radius: 12px; overflow: hidden; aspect-ratio: 1/1; display: flex; align-items: center; justify-content: center;">
                  <img src="${escapeHtml(shopifyImageUrl(product.image_url, 600))}"
                       srcset="${shopifyImageSrcset(product.image_url, [400, 600, 800])}"
                       sizes="(max-width: 768px) 90vw, 45vw"
                       alt="${escapeHtml(product.full_title)}" style="width: 100%; height: 100%; object-fit: contain;">
                </div>
              </div>
              <div style="display: flex; flex-direction: column;">
                ${product.vendor ? `<div style="font-size: 12px; color: #6b7280; text-transform: uppercase; letter-spacing: 1.2px; margin-bottom: 12px; font-weight: 700;">${escapeHtml(product.vendor)}</div>` : ''}
                <h3 style="font-size: 28px; font-weight: 700; margin: 0 0 20px; line-height: 1.2; color: #111827;">${escapeHtml(product.full_title)}</h3>
                ${priceHtml}
                ${metadataHtml}
                <div style="color: #4b5563; line-height: 1.7; margin-bottom: 28px; font-size: 15px;">${product.description ? sanitizeHtml(product.description) : 'No description available.'}</div>
                <div style="margin-top: auto; padding-top: 20px; border-top: 1px solid #f3f4f6; display: flex; flex-direction: column; gap: 12px;">
                  <a href="${product.url}" style="display: flex; align-items: center; justify-content: center; gap: 10px; width: 100%; padding: 16px 32px; background: #000000; color: white; text-decoration: none; border-radius: 4px; font-weight: 700; font-size: 15px; transition: all 0.2s; box-shadow: 0 2px 4px rgba(0,0,0,0.1);" onmouseover="this.style.background='#1a1a1a'; this.style.transform='translateY(-1px)'; this.style.boxShadow='0 4px 8px rgba(0,0,0,0.15)';" onmouseout="this.style.background='#000000'; this.style.transform='translateY(0)'; this.style.boxShadow='0 2px 4px rgba(0,0,0,0.1)';">
                    View Full Details
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M5 12h14M12 5l7 7-7 7"/>
                    </svg>
                  </a>
                  <button onclick="${product.variant_count > 1 ? `window.location.href='${product.url}'` : `buyNow('${product.variant_id}')`}" style="display: flex; align-items: center; justify-content: center; gap: 10px; width: 100%; padding: 16px 32px; background: #2183DF; color: white; border: none; border-radius: 4px; font-weight: 700; font-size: 15px; cursor: pointer; transition: all 0.2s; box-shadow: 0 2px 4px rgba(0,0,0,0.1);" onmouseover="this.style.background='#1a6fc2'; this.style.transform='translateY(-1px)'; this.style.boxShadow='0 4px 8px rgba(0,0,0,0.15)';" onmouseout="this.style.background='#2183DF'; this.style.transform='translateY(0)'; this.style.boxShadow='0 2px 4px rgba(0,0,0,0.1)';">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="9" cy="21" r="1"></circle>
                      <circle cx="20" cy="21" r="1"></circle>
                      <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                    </svg>
                    Buy Now
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      `;
      modal.style.display = 'block';
      document.body.style.overflow = 'clip';
  
      // Add CSS animations
      const style = document.createElement('style');
      style.textContent = `
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @media (max-width: 768px) {
          .quick-view-content > div:last-child {
            grid-template-columns: 1fr !important;
            gap: 24px !important;
            padding: 24px !important;
          }
        }
      `;
      if (!document.getElementById('quick-view-animations')) {
        style.id = 'quick-view-animations';
        document.head.appendChild(style);
      }
    };
  
    window.closeQuickView = function() {
      const modal = document.getElementById('quick-view-modal');
      modal.style.display = 'none';
      modal.innerHTML = '';
      document.body.style.overflow = '';
    };
  
    window.buyNow = async function(variantId) {
      DEBUG && console.log('Buy Now clicked, variantId:', variantId);
  
      // Handle undefined/null/empty variant IDs
      if (!variantId || variantId === 'undefined' || variantId === 'null' || variantId === '') {
        alert('Unable to add to cart. This product requires variant selection - please view the full product page.');
        return;
      }
  
      const btn = event.target.closest('button');
      const originalText = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="animation: spin 1s linear infinite;"><circle cx="12" cy="12" r="10" stroke-dasharray="32" stroke-dashoffset="12"></circle></svg> Processing...';
  
      try {
        // Ensure variant ID is sent as a number (Shopify expects numeric ID)
        const numericVariantId = parseInt(variantId, 10);
        if (isNaN(numericVariantId)) {
          throw new Error('Invalid variant ID');
        }
  
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: numericVariantId, quantity: 1 })
        });
  
        if (response.ok) {
          window.location.href = '/checkout';
        } else {
          const error = await response.json();
          DEBUG && console.error('Cart add error:', error);
          alert(error.description || 'Unable to add to cart');
          btn.disabled = false;
          btn.innerHTML = originalText;
        }
      } catch (error) {
        DEBUG && console.error('Buy now error:', error);
        alert('Something went wrong. Please try again.');
        btn.disabled = false;
        btn.innerHTML = originalText;
      }
    };
  
    DEBUG && console.log('✅ Meilisearch search initialized');
  })();
  });
  